import {generateProductHtml} from "./ob-generate-product-html.js?v=364"

let glob_designs = []; // Designs from metaobjects, used for print filter
let pageSize = 30;
let labelList;
let filters = [];
let currentSort = []; 
const currentPageNumber = document.getElementById("current-product-number");
const collectionTotalProducts = document.getElementById("collection-total-products");
const nextPageButton = document.getElementById("coll-see-more");
const equivelant100 = parseFloat(document.getElementById("100-money").value);
const currencySymbol = document.body.getAttribute("currency-symbol")
const is_sale = document.body.dataset.sale == "true";
const countryIso = document.body.getAttribute("country-iso");
let currentWishlistItem = null;
let globData = {};


let language = document.body.getAttribute("language");


// Debug function to control logging
const debug = {
    enabled: false,
    log: function(...args) {
        if (this.enabled) {
            console.log(...args);
        }
    },
    error: function(...args) {
        if (this.enabled) {
            console.error(...args);
        }
    }
};

// Only modify pageSize if both elements exist and collectionTotalProducts has a valid value
if (currentPageNumber && collectionTotalProducts && collectionTotalProducts.innerHTML) {
    const totalProducts = parseInt(collectionTotalProducts.innerHTML);
    if (!isNaN(totalProducts) && totalProducts < pageSize) {
        pageSize = totalProducts;
    }
}
const sizeMap = new Map([ //used to group sizes for size filter
    ["4XL", ["size-4xl", "title-size-4xl"]],
    ["3XL", ["size-3xl", "title-size-3xl"]],
    ["2XL", ["size-2xl", "title-size-2xl"]],
    ["XL", ["size-xl", "title-size-xl"]],
    ["large", ["size-large", "title-size-large"]],
    ["medium", ["size-medium", "title-size-medium"]],
    ["small", ["size-small", "size-s", "title-size-small"]],
    ["XS", ["size-xs", "title-size-xs"]],
    ["2XS", ["size-xxs", "title-size-xxs"]],
    ["1-2", ["size-1-2"]],
    ["3-6", ["size-3-6"]],
    ["7-10", ["size-7-10"]],
    ["11-13", ["size-11-13"]],
    ["Size 6", ["title-size-6"]],
    ["Size 8", ["title-size-8"]],
    ["Size 10", ["title-size-10"]],
    ["Size 12", ["title-size-12"]],
    ["Size 14", ["title-size-14"]],
    ["Size 16", ["title-size-16"]],
    ["Size 18", ["title-size-18"]],
    ["Size 20", ["title-size-20"]],
    ["5-6 yrs", ["size-5-6-yrs"]],
    ["6-7 yrs", ["size-6-7-yrs"]],
    ["7-8 yrs", ["size-7-8-yrs"]],
    ["9-10 yrs", ["size-9-10-yrs"]],
    ["11-12 yrs", ["size-11-12-yrs"]]

]);

async function get_designs() {
    // Pull print information from metaobjects, store in above array
    const design_url = 'https://www.myoddballs.com/pages/gift-ideas-for-all-occasions?view=get-designs';
    try {
        const response = await fetch(design_url);
        const data = await response.text();
        glob_designs = JSON.parse(data).designs
    } catch (error) {
        console.error('Error fetching designs:', error);
    }
}

async function get_labels() {
    const countryUrl = document.body.getAttribute("country-url");
    const url = countryUrl ? `https://www.myoddballs.com${countryUrl}/pages/perfect-pair?view=labels` : "https://www.myoddballs.com/pages/perfect-pair?view=labels";

    const data12 = await fetch(url);
    const html = await data12.text();

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    let tempLabels = []
    const inputs = doc.querySelectorAll("input.tag");
    inputs.forEach(input => {
        tempLabels.push(JSON.parse(input.value));
    });
    labelList = tempLabels;
}

function displayNetworkError(messageTooLog) {
    const ajaxContainer = document.getElementById('AjaxinateContainer');
    const collectionGrid = document.getElementById('collectionGridWrap')
    let errorDiv = document.createElement('div')
    errorDiv.setAttribute("data-cro-loaded", "collection-error")
    errorDiv.style.display = "none"
    ajaxContainer.prepend(errorDiv)
    errorDiv.textContent = messageTooLog;
    collectionGrid.classList.remove('grid-loading')


}

function waitForNostoJs(callback) {
    const checkInterval = setInterval(function() {
        if (typeof window.Nosto !== 'undefined') {
            clearInterval(checkInterval);
            callback();
        }
    }, 100); // Check every 100 milliseconds
}

const searchPageInput = document.getElementById('page-search-query');

function initNostoDependentFunctions() {
    if (searchPageInput) { //get products for search
        let query = searchPageInput.value;
        fetchSearchProducts(query);
    } else {
        const pageParam = new URL(window.location.href).searchParams.get('page') || '1';
        if (pageParam == "1") {
            fetchCollProducts();
        } else {
            nextPageButton.setAttribute("data-page-loc", pageSize * (pageParam - 1));
            fetchCollPage(false);
        }
    }
}

const getUpdatedCache = async () => {
    try {
        const res = await fetch("https://oddbals-collection-sort--development.gadget.app/nosto-cache", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ collId: window_collection_id })
        });

        const json = await res.json();
       
        return json.data;
    } catch (err) {
        console.error("Fetch error:", err);
    }
};

const getNewProds = async() => {
    console.log("getting new prods")
    const data = await getUpdatedCache();
    const prods = data.nostoProds;
    const facets = data.nostoFacets;
    if(!prods){
        initNostoDependentFunctions()
        return
    }else{
        return {prods, facets}
    }
}

const checkCache = async() => {
        const now = Date.now();
        const lastUpdated = new Date(nosto_cache_date).getTime();

       
        const ONE_DAY = 24 * 60 * 60 * 1000;
        let prods
        let facets
        let target = document.getElementById("AjaxinateContainer")
        const usingCacheInput = document.getElementById("using-nosto-cache");
        const cancelCache = usingCacheInput?.value == "false";
        if (now - lastUpdated > ONE_DAY || cancelCache) {
        // if (now - lastUpdated > 0) {
            ({prods, facets} = await getNewProds())
        } else {
            try{
                
                facets = nosto_cache_data.nostoFacets;
                prods = nosto_cache_data.nostoProds;
                globData.facets = facets;
                globData.total = prods.length;
                prodsAddedFlag = true;
                addLabels();
                sortFilters(facets, prods.length);
                let allFilters = document.querySelector(".collection-nav-link-reset-filter");
                if(allFilters){
                    allFilters.classList.add("active");
                }
                const currency = document.body.getAttribute("currency");
                if (currency != "GBP") {
                    const updatePromises = prods.map(product => updateNonUKPrices(product.productId));
                    await Promise.all(updatePromises);
                    const priceLoadingDivs = document.querySelectorAll(".price-loading");
                    priceLoadingDivs.forEach((a)=>{
                        a.classList.remove("price-loading")
                    })
                }
                
                return
            }catch(error){
                console.error(error.message);
                 const colletionGridWrap = document.getElementById("collectionGridWrap");
                    collectionGridWrap.classList.add("grid-loading")
                    const loadingProd = `<div class="product-card__details sm:px-0 h-full pb-2"><div class="bg-gray-100 justify-center p-3"><div class="rounded-full border border-black border-solid grid grid-cols-2 w-full bg-white sm:max-w-[90%] mx-auto"><a id="collection-see-more-1" href="/products/best-of-winter-sale-bundle-mens-boxer-shorts-7-pack" class="text-xxs md:text-xs items-center text-center uppercase border-r border-solid border-gray-300 py-2 md:py-2 font-semibold md:font-normal">see more</a><div id="collection-quick-buy-1" class="event-quickbuy-show quick-add-wrapper text-xxs md:text-xs items-center text-center uppercase coll-quick-add py-2 font-semibold md:font-normal relative md:py-2 flex justify-center" data-cro-feature-clicked="grid-item-quick-buy"><div class="quick-buy-text" data-cro-feature-clicked="grid-item-quick-buy">quick buy</div><div class="absolute left-0 coll-quick-add z-2" data-handle="best-of-winter-sale-bundle-mens-boxer-shorts-7-pack" data-cro-feature-clicked="grid-item-quick-buy" style="top: -50%; width: 120%; height: 195%;"></div><div class="w-4 quick-buy-loader"><svg class="loading-ele-outer" viewBox="25 25 50 50"><circle class="loading-ele-inner" cx="50" cy="50" r="20" fill="none" stroke-width="4"></circle></svg></div></div></div></div><a id="collection-product-title-1" class="h-full flex flex-col justify-between" href="/products/best-of-winter-sale-bundle-mens-boxer-shorts-7-pack"><div><p class="product-card__details__title px-2 font-semibold flex"><div style="width: 0px; flex-grow: 1;">The Biggest Birthday Bundle</div></p><p class="product-card__details__color px-2">Mens Boxer Shorts 7 Pack</p></div><div><p class="product-card__details__price px-2 text-magenta-500 text-md">£58.80<del class="ml-1 text-gray-400">£84</del></p></div></a></div>`
                    for(let i=0; i< 12; i++){
                        target.innerHTML += loadingProd;
                    }
                 
                    ({prods, facets} = await getNewProds())
            }
        }
        target.innerHTML = ""
        prods.forEach((product, index)=>{
            const prodCard = generateProductHtml({product,index})
            if(prodCard){
                target.append(prodCard)
            }
        })
        const currency = document.body.getAttribute("currency");
                if (currency != "GBP") {
                    const updatePromises = prods.map(product => updateNonUKPrices(product.productId));
                    await Promise.all(updatePromises);
                    const priceLoadingDivs = document.querySelectorAll(".price-loading");
                    priceLoadingDivs.forEach((a)=>{
                        a.classList.remove("price-loading")
                    })
                }
        prodsAddedFlag = true;
        addLabels();
        sortFilters(facets, prods.length);
        const colletionGridWrap = document.getElementById("collectionGridWrap");
        collectionGridWrap.classList.remove("grid-loading")

}

document.addEventListener('DOMContentLoaded', function() {

    (async () => {
        waitForNostoJs(async function() {
            let isFiltered = false;
            const queryString = window.location.search;
            const params = new URLSearchParams(queryString);
            params.forEach((value, key) => {
                if (key.includes("filter-")) {
                    isFiltered = true;
                }
            });
            const shopifyFilteredInput = document.getElementById("shopify-filtered-collection")
            if(shopifyFilteredInput){
                isFiltered = isFiltered || shopifyFilteredInput.value == "true"
            }
            if(isFiltered){
                document.getElementById("collectionGridWrap").classList.add("grid-loading")
            }
            if(!should_nosto_cache || isFiltered){
                initNostoDependentFunctions();
            }else{
                checkCache();
            }
            await Promise.all([get_designs(), get_labels()]);
            // addLabels();
        });
    })();
})
let prodsAddedFlag = false;

function addLabels(count = 0) {
    let newcount = count + 1;
    if(newcount > 20) return;
    const products = document.querySelectorAll('.product-card');
    if (prodsAddedFlag && labelList) {
        products.forEach(function(card) {
            try {
                if(card.classList.contains("nosto_element")){
                    return;
                }
                // Find the input element with class 'prod-info' within the current card
                let prodInfo = card.querySelector('.prod-info');
                let prod = JSON.parse(prodInfo.value); // Use the value of the input element
                let label = generateProductLabel(prod);
                if(card.classList.contains("flash-sale-product")){
                    const progBar = card.querySelector(".sale-progress-bar");
                    const funkyBg = progBar?.style.background;
                    label = `<span class="flash-sale-label flex items-center absolute top-2 right-2 rounded font-display text-3xs lg:!text-md  font-bold uppercase rounded-md" style="z-index:12;
                     background: ${progBar? funkyBg : "#f00"};
                      color:#fff; border: 2px solid #F00${progBar && "0"}; box-shadow: 1px 1px 1px rgb(0 0 0 / 30%);">
                    <div style="background:black; padding: 0.25rem; border-radius: 0.305rem; display: flex; align-items: center;">
<svg height="20px" width="20px" style="stroke: white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="#fff" x="0px" y="0px"><path d="M4.03196 18.98H6.77929C7.71819 16.6885 8.86513 14.4879 10.2057 12.4058C10.8009 11.5816 11.3945 10.8033 11.9864 10.0709C10.6318 10.189 9.31106 10.5582 8.09154 11.1595C6.85362 11.8141 5.8199 12.797 5.10379 14.0003C4.38768 15.2037 4.01684 16.5811 4.03196 17.9814V18.98Z" fill="black"/><path d="M13.02 25.2207C15.3116 24.2802 17.5123 23.1316 19.5942 21.7893C20.4218 21.1947 21.2001 20.6029 21.9291 20.0137C21.811 21.3682 21.4418 22.6889 20.8405 23.9085C20.1859 25.1464 19.203 26.1801 17.9997 26.8962C16.7963 27.6123 15.4189 27.9832 14.0186 27.968H13.02V25.2207Z" fill="black"/><path fill-rule="evenodd" clip-rule="evenodd" d="M28 7C27.8613 11.3428 24.7311 15.65 18.4308 20.1694C16.7146 21.282 14.904 22.2417 13.02 23.0376V22.4754C13.0155 21.5497 12.6458 20.6633 11.9913 20.0087C11.3367 19.3542 10.4503 18.9845 9.52463 18.98H8.96238C9.75922 17.096 10.7203 15.2858 11.8346 13.5702C16.3475 7.27364 20.6518 4.14381 24.992 4C24.9947 4 24.9973 4 25 4H28V7ZM21.2767 10.7233C21.7449 11.1915 22.008 11.8265 22.008 12.4887C22.008 13.1508 21.7449 13.7859 21.2767 14.2541C20.8085 14.7223 20.1735 14.9854 19.5113 14.9854C18.8492 14.9854 18.2141 14.7223 17.7459 14.2541C17.2777 13.7859 17.0146 13.1508 17.0146 12.4887C17.0146 11.8265 17.2777 11.1915 17.7459 10.7233C18.2141 10.2551 18.8492 9.99201 19.5113 9.99201C20.1735 9.99201 20.8085 10.2551 21.2767 10.7233Z" fill="black"/><path d="M10.1458 26.0915C9.24001 26.9963 6.52863 27.5536 5.40413 27.7533L4 28L4.24667 26.5959C4.44541 25.4714 5.00366 22.76 5.90846 21.8542C6.47036 21.2923 7.23247 20.9766 8.02713 20.9766C8.42061 20.9766 8.81023 21.0541 9.17375 21.2047C9.53727 21.3553 9.86758 21.576 10.1458 21.8542C10.424 22.1324 10.6447 22.4627 10.7953 22.8263C10.9459 23.1898 11.0234 23.5794 11.0234 23.9729C11.0234 24.3663 10.9459 24.756 10.7953 25.1195C10.6447 25.483 10.424 25.8133 10.1458 26.0915Z" fill="black"/></svg>                    Launch Offer
                    </div>
                    </span>
`
                }

                // Find the element with class 'label-loc' within the current card
                let labelLoc = card.querySelector('.label-loc');
                labelLoc.innerHTML = label; // Set the innerHTML to the generated label
            } catch (error) {
                console.error("Error adding label: " + error);
            }
        });
    } else {
        setTimeout(function() {
            addLabels(newcount);
        }, 300)
    }


}

function generateProductLabel(data) {
    let available = data.available;
    const current_id = data.productId;
    const image_url = data.imageUrl;
    let prod_price = data.price;
    let comp_price = data.listPrice;
    const current_title = data.name;
    const tags = data.tags1;

    let label_found = false;
    let savings = 0;

    for (const label of labelList) {
        let proceed = false

        if (label.theme_version == "A") {
            proceed = true;
        }

        if (label && proceed) {
            let labelMatch = label.tag_match;
            let bgColor = label.bg_color;
            let textColor = label.text_color;
            let labelText = label.text;
            let labelBorder = label.outline_color
            let countryUrl = document.body.getAttribute("country-url");
            let marketIso = document.body.getAttribute("market");
            const labelDisplay = label.show_hide_class

            if (!Array.isArray(tags)) continue;
            for (const tag of tags) {
                if (tag === labelMatch && !label_found) {
                    if(tag === "label-launch-offer"){
 return `<span class="flash-sale-label flex items-center absolute top-2 right-2 rounded font-display text-3xs lg:!text-md  font-bold uppercase rounded-md" style="z-index: 12; background: linear-gradient(rgb(255, 255, 255), rgb(255, 255, 255)) padding-box padding-box, linear-gradient(to right, rgb(186, 8, 81) 0%, rgb(244, 20, 153) 33%, rgb(249, 120, 203) 66%, rgb(244, 20, 153) 100%); color: rgb(255, 255, 255); box-shadow: rgba(0, 0, 0, 0.3) 1px 1px 1px; border: 2px solid transparent;">
                    <div style="background:black; padding: 0.25rem; border-radius: 0.305rem; display: flex; align-items: center;">
<svg height="20px" width="20px" style="stroke: white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="#fff" x="0px" y="0px"><path d="M4.03196 18.98H6.77929C7.71819 16.6885 8.86513 14.4879 10.2057 12.4058C10.8009 11.5816 11.3945 10.8033 11.9864 10.0709C10.6318 10.189 9.31106 10.5582 8.09154 11.1595C6.85362 11.8141 5.8199 12.797 5.10379 14.0003C4.38768 15.2037 4.01684 16.5811 4.03196 17.9814V18.98Z" fill="black"></path><path d="M13.02 25.2207C15.3116 24.2802 17.5123 23.1316 19.5942 21.7893C20.4218 21.1947 21.2001 20.6029 21.9291 20.0137C21.811 21.3682 21.4418 22.6889 20.8405 23.9085C20.1859 25.1464 19.203 26.1801 17.9997 26.8962C16.7963 27.6123 15.4189 27.9832 14.0186 27.968H13.02V25.2207Z" fill="black"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M28 7C27.8613 11.3428 24.7311 15.65 18.4308 20.1694C16.7146 21.282 14.904 22.2417 13.02 23.0376V22.4754C13.0155 21.5497 12.6458 20.6633 11.9913 20.0087C11.3367 19.3542 10.4503 18.9845 9.52463 18.98H8.96238C9.75922 17.096 10.7203 15.2858 11.8346 13.5702C16.3475 7.27364 20.6518 4.14381 24.992 4C24.9947 4 24.9973 4 25 4H28V7ZM21.2767 10.7233C21.7449 11.1915 22.008 11.8265 22.008 12.4887C22.008 13.1508 21.7449 13.7859 21.2767 14.2541C20.8085 14.7223 20.1735 14.9854 19.5113 14.9854C18.8492 14.9854 18.2141 14.7223 17.7459 14.2541C17.2777 13.7859 17.0146 13.1508 17.0146 12.4887C17.0146 11.8265 17.2777 11.1915 17.7459 10.7233C18.2141 10.2551 18.8492 9.99201 19.5113 9.99201C20.1735 9.99201 20.8085 10.2551 21.2767 10.7233Z" fill="black"></path><path d="M10.1458 26.0915C9.24001 26.9963 6.52863 27.5536 5.40413 27.7533L4 28L4.24667 26.5959C4.44541 25.4714 5.00366 22.76 5.90846 21.8542C6.47036 21.2923 7.23247 20.9766 8.02713 20.9766C8.42061 20.9766 8.81023 21.0541 9.17375 21.2047C9.53727 21.3553 9.86758 21.576 10.1458 21.8542C10.424 22.1324 10.6447 22.4627 10.7953 22.8263C10.9459 23.1898 11.0234 23.5794 11.0234 23.9729C11.0234 24.3663 10.9459 24.756 10.7953 25.1195C10.6447 25.483 10.424 25.8133 10.1458 26.0915Z" fill="black"></path></svg>                    Launch Offer
                    </div>
                    </span>`
                    }
                    else if (tag === "label-sale-percent-discount") {
                        if (parseFloat(comp_price) > parseFloat(prod_price)) {
                            label_found = true;
                            savings = ((comp_price - prod_price) / comp_price * 100).toFixed(2);
                            return `<span class="${labelDisplay} top-2 right-2 rounded px-1.5 py-1 font-display text-3xs lg:!text-md  font-bold uppercase rounded-md" style="z-index:12; background-color: ${bgColor}; color:${textColor}; border: 2px solid ${labelBorder}; box-shadow: 1px 1px 1px rgb(0 0 0 / 30%);">${Math.round(savings)}${translations.collections.percent_saving}</span>`;
                        }
                    } else if (tag === "label-sale-value-discount") {
                        if (parseFloat(comp_price) > parseFloat(prod_price)) {
                            label_found = true;
                            savings = comp_price - prod_price;
                            if (savings % 1 !== 0) {
                                savings = savings.toFixed(2); // Format to 2 decimal places
                            }
                            if(marketIso == "se" && data.name.toLowerCase().includes("bundle")){
                                return `<span class="${labelDisplay} top-2 right-2 rounded px-1.5 py-1 font-display text-3xs lg:!text-md  font-bold uppercase rounded-md" style="z-index:12; background-color: ${bgColor}; color:${textColor}; border: 2px solid ${labelBorder}; box-shadow: 1px 1px 1px rgb(0 0 0 / 30%);">Köp fler – spara mer</span>`
                            }
                            return `<span class="${labelDisplay} top-2 right-2 rounded px-1.5 py-1 font-display text-3xs lg:!text-md  font-bold uppercase rounded-md" style="z-index:12; background-color: ${bgColor}; color:${textColor}; border: 2px solid ${labelBorder}; box-shadow: 1px 1px 1px rgb(0 0 0 / 30%);">Save ${GEBO.settings.shop_money_format.replace(/\{\{.*?\}\}/, savings)}</span>`;
                        }
                    } else {
                        // default label handling
                        label_found = true;
                        return `<span class="${labelDisplay} top-2 right-2 rounded px-1.5 py-1 font-display text-3xs lg:!text-md font-bold uppercase rounded-md" style="z-index:12; background-color: ${bgColor}; color:${textColor}; border: 2px solid ${labelBorder}; box-shadow: 1px 1px 1px rgb(0 0 0 / 30%);">${labelText}</span>`;
                    }
                }
            }
        }
    }
    return null;
}

let urlFilterFlag = false || window.location.href.includes("fbclid"); //used to check if collection is already filtered through the url also stops if is facebook add


const fetchCustomerWishlist = async (id) =>{
        const url = `https://oddballs-whishlist--development.gadget.app/apps/oddballs-wishlist/get-wishlist?customerId=${id}`;
        const res = await fetch(url);
        const data = await res.json()
        const ids = data.map((prod)=>{
            return prod.id.replace("gid://shopify/Product/", "")
        })
        return(ids)
}
const fullHeartAnimation = document.createElement("div");
fullHeartAnimation.className = "wishlist-animation w-full h-full heartAnimate"
const fullHeartImage = document.createElement("img");
fullHeartImage.src = "https://cdn.shopify.com/s/files/1/0353/7249/files/Heart_FILL.png"
fullHeartImage.style.height="40px";
fullHeartImage.style.width="50px";

const sortCollectionWishlist = async () => {
    try{

        const customerInput = document.getElementById("customer-id-input");
        const customerId = customerInput?.value;  
        const wishlistButtons = document.querySelectorAll(".collection-wishlist-trigger");
        if(!customerId){
            wishlistButtons.forEach((button)=>{
        button.classList.add("open-wishlist-popup")
    })
      return;
    }
    let wishlistIds = await fetchCustomerWishlist(customerId);
    wishlistButtons.forEach((button)=>{
        const wrapper = button.closest(".product-card");
        const prodjson = JSON.parse(wrapper.querySelector(".prod-info").value);
        const id = prodjson.productId;
        if(currentWishlistItem){
            if(currentWishlistItem != id){
                return
            }
        }
        button.classList.remove("collection-in-wishlist")
        button.classList.remove("collection-not-in-wishlist")
        const inWishlist = wishlistIds.some((wishlistId) => {
            return wishlistId == id;
        })
        if (inWishlist){
            button.classList.add("collection-in-wishlist");
            button.innerHTML = fullHeartImage.outerHTML;
            
        }else{
            button.innerHTML = heartSvg;
            button.classList.remove("previously-in-wishlist")
            button.classList.add("collection-not-in-wishlist")
        }
    })

    }catch(error){
        console.error(error.message)
    }   
    
}


function fetchCollPage(isPage = true) {

    const collHandleDiv = document.getElementById("coll-handle");
    const collHandle = collHandleDiv.value;
    const currentURL = window.location.href;
    const urlParts = currentURL.split("/");
    let filterTag = "";
    const queryString = window.location.search;
    const params = new URLSearchParams(queryString);
    const urlFilters = [];
    params.forEach((value, key) => {
        if (key.includes("filter-")) {
            urlFilters.push({
                key,
                value
            });
        }
    });


    const urlFiltersToAdd = urlFilters.map(({
        key,
        value
    }) => {
        return {
            "field": key.replace("filter-", ""),
            "value": value
        };
    })
    urlFiltersToAdd.forEach((filter) => {
        filters.push(filter)
    })
    const currentUrl = window.location.href.split('?')[0];
    const newParams = new URLSearchParams(queryString);
    filters.forEach((filter) => {
        const key = `filter-${filter.field}`;
        const existingValues = newParams.getAll(key);
        if (!existingValues.includes(filter.value)) {
            newParams.append(key, filter.value);
        }
    });

    const newUrl = `${currentUrl}?${newParams.toString()}`;

    window.history.replaceState(null, "", newUrl);
    const idInput = document.getElementById("coll-id");
    const collectionid = idInput.value;
    let filtersString = '';
    let sortString = '';
    let queryObject = {};

    if (filters.length > 0) {
        // Convert filters to JSON string and adjust field names
        const filtersJson = JSON.stringify(filters)
            .replace(/"field":/g, 'field:')
            .replace(/"lte":/g, 'lte:')
            .replace(/"gte":/g, 'gte:')
            .replace(/"range":/g, 'range:')
            .replace(/"value":/g, 'value:');

        filtersString = `, filter: ${filtersJson}`;
    } else {
        // document.getElementById('nosto-filters-wrapper').style.display = 'none';
        // document.getElementById('nosto-search-active-filters').innerHTML = '';
    }

    if (currentSort.length > 0) {
        sortString = ",sort:" + JSON.stringify(currentSort)
            .replace(/"field":/g, 'field:')
            .replace(/"order":/g, 'order:')
            .replace(/"asc"/g, 'asc')
            .replace(/"desc"/g, 'desc');
    }


    const currentPageLoc = parseInt(nextPageButton.getAttribute("data-page-loc"));
    nostojs(api => {
        api.search({
                products: {
                    fields: ["name", "price", "listPrice", "imageUrl", "url", "available", "tags1", "categories", "alternateImageUrls", "skus.id", "skus.name", "skus.availability", "skus.customFields.key", "skus.customFields.value", "customFields.key", "customFields.value"],
                    size: pageSize,
                    categoryId: collectionid,
                    facets: ['*'],
                    filter: filters,
                    sort: currentSort,
                    from: currentPageLoc
                },
                keywords: {
                    fields: ["keyword"]
                }
            }, {
                track: 'category',
            }).then(data => {
                document.getElementById("coll-see-more").classList.remove("see-more-loading");
                currentPageNumber.innerHTML = currentPageLoc + data.products.hits.length;
                globData.facets = data.products.facets;
                globData.total = data.products.total
                if (data.products.total <= pageSize) {
                    document.getElementById("coll-see-more").style.display = "none";
                }
                const bluredItems = document.querySelectorAll('.nosto-blur');
                bluredItems.forEach(item => {
                    item.classList.remove('nosto-blur');
                });
                sortFilters(globData.facets, globData.total);
                const loadingItems = document.querySelectorAll('.loading-grid-item');
                loadingItems.forEach(item => item.remove());
                let products = data.products.hits;
                if (currentSort != "") {
                    products = products.filter((prod) => {
                        return !prod.name.toLowerCase().includes("mid-collection") && !prod.name.toLowerCase().includes("mid collection");
                    });

                }
                remLoadingProds();

                let target = document.getElementById("AjaxinateContainer");
                document.getElementById("collectionGridWrap").classList.remove("grid-loading")
                addCollectionItems(products, target, isPage);
                sortCollectionWishlist()

            })
            .catch((error) => {
                console.error(error);
                displayNetworkError("error fetching from  api" + error)
            });
    });
}

let newFilterFlag = false;

const sortPopularFilters = (filters) => {
    try{
        let secondFilterFound = false;
        filters.forEach((filter)=>{
        let valueCount = filter.value.length;
        // const dropDown = document.querySelector(`.collection-filter-dropdown:has([data-filter-type='${filter.field}'`)
        // const dropDownTarget = dropDown.querySelector(`.collection-filter-dropdown-option-chosen-value`)
        // dropDownTarget.innerHTML = valueCount;
        if(filter.value){
            let value = Array.isArray(filter.value) ? filter.value[0] : filter.value; 
            let secondPopularFilter = document.querySelector(`.collection-nav-link-with-filter[data-filter-type="${filter.field}"][data-filter-value="${value}"]`)
            if(secondPopularFilter){
                secondFilterFound = true;
                    secondPopularFilter.classList.add("active"); 
                }
            const sizeFilter = document.querySelector(`.collection-multi-filtersize-option[data-filter-type="${filter.field}"][data-filter-value="${value}"]`)
            if(sizeFilter){
                sizeFilter.classList.add("active")
            }
        }
    })
        let allFilters = document.querySelector(".collection-nav-link-reset-filter");
    if(!secondFilterFound){
        if(allFilters){
            allFilters.classList.add("active");
        }
    }else{
        if(allFilters){
            allFilters.classList.remove("active");
        }
    }
}catch(error){
    console.error(error.message)
}
}

function fetchCollProducts() {

    const collHandleDiv = document.getElementById("coll-handle");
    const collHandle = collHandleDiv?.value;
    const currentURL = window.location.href;
    const urlParts = currentURL.split("/");
    let filterTag = "";

    if (!newFilterFlag) {
        newFilterFlag = true;

        const queryString = window.location.search;
        const params = new URLSearchParams(queryString);
        const urlFilters = [];

        params.forEach((value, key) => {
            if (key.includes("filter-")) {
                urlFilters.push({
                    key,
                    value
                });
            }
        });

        const urlFiltersToAdd = urlFilters.map(({
            key,
            value
        }) => {
            const field = key.replace("filter-", "");
            if (field === "price") {
                const [gte, lte] = value.split("-");
                return {
                    field,
                    range: {
                        gte,
                        lte
                    },
                };
            }
            return {
                field,
                value: value.split(","),
            };
        });

        urlFiltersToAdd.forEach((filter) => {
            filters.push(filter);
        });
    }

    const currentUrl = window.location.href.split('?')[0];
    const newParams = new URLSearchParams();

    filters.forEach((filter) => {
        const key = `filter-${filter.field}`;
        if (filter.field === "price") {
            const {
                gte,
                lte
            } = filter.range;
            newParams.append(key, `${gte}-${lte}`);
        } else {
            newParams.append(key, filter.value.join(","));
        }
    });


    const newUrl = `${currentUrl}?${newParams.toString()}`;
    if (filters.length > 0) {

        window.history.replaceState(null, "", newUrl);
    }




    if (!urlFilterFlag) {
        for (let i = 0; i < urlParts.length; i++) {
            if (urlParts[i] === collHandle) {
                filterTag = urlParts[i + 1] ? urlParts[i + 1] : "";
                break;
            }
        }
        if (filterTag != "") {
            filterTag = filterTag.split("?")[0];
            urlFilterFlag = true;
            const newFilter = {
                "field": "tags1",
                "value": filterTag
            };
            filters.push(newFilter)
        }

    }

    sortPopularFilters(filters)


    const idInput = document.getElementById("coll-id");
    const collectionid = idInput.value;
    let filtersString = '';
    let sortString = '';
    let queryObject = {};

    if (filters.length > 0) {
        // Convert filters to JSON string and adjust field names
        const filtersJson = JSON.stringify(filters)
            .replace(/"field":/g, 'field:')
            .replace(/"lte":/g, 'lte:')
            .replace(/"gte":/g, 'gte:')
            .replace(/"range":/g, 'range:')
            .replace(/"value":/g, 'value:');

        filtersString = `, filter: ${filtersJson}`;
    } else {
        // document.getElementById('nosto-filters-wrapper').style.display = 'none';
        // document.getElementById('nosto-search-active-filters').innerHTML = '';
    }

    if (currentSort.length > 0) {
        sortString = ",sort:" + JSON.stringify(currentSort)
            .replace(/"field":/g, 'field:')
            .replace(/"order":/g, 'order:')
            .replace(/"asc"/g, 'asc')
            .replace(/"desc"/g, 'desc');
    }
    nostojs(api => {
        api.search({
                products: {
                    fields: ["name", "price", "listPrice", "imageUrl", "url", "available", "tags1", "categories", "alternateImageUrls", "skus.id", "skus.name", "skus.availability", "skus.customFields.key", "skus.customFields.value", "customFields.key", "customFields.value"],
                    size: pageSize,
                    categoryId: collectionid,
                    facets: ['*'],
                    filter: filters,
                    sort: currentSort
                },
                keywords: {
                    fields: ["keyword"]
                }
            }, {
                track: 'category',
            }).then(data => {
                collectionTotalProducts.innerHTML = data.products.total;
                const currentPageLoc = parseInt(nextPageButton.getAttribute("data-page-loc"));
                if (currentPageNumber && currentPageLoc) {
                }
                currentPageNumber.innerHTML = data.products.hits.length;
                globData.facets = data.products.facets;
                globData.total = data.products.total
                if (data.products.total <= pageSize) {
                    document.getElementById("coll-see-more").style.display = "none";
                }
                const bluredItems = document.querySelectorAll('.nosto-blur');
                bluredItems.forEach(item => {
                    item.classList.remove('nosto-blur');
                });
                sortFilters(data.products.facets, data.products.total);

                const loadingItems = document.querySelectorAll('.loading-grid-item');
                loadingItems.forEach(item => item.remove());
                let products = data.products.hits;
                if (filtersString != "") {
                    document.querySelectorAll(".nosto-dynamic.product-card").forEach(el => el.style.display = "none");
                } else {
                    // document.querySelectorAll(".nosto-dynamic.product-card").forEach(el => el.style.display="block");
                }
                if (currentSort != "") {
                    document.querySelectorAll(".nosto-dynamic.product-card").forEach(el => el.remove());
                    products = products.filter((prod) => {
                        return !prod.name.toLowerCase().includes("mid-collection") && !prod.name.toLowerCase().includes("mid collection");
                    });

                }
                remLoadingProds();
                let target = document.getElementById("AjaxinateContainer");
                target.classList.remove("collection-filtering")
                document.getElementById("collectionGridWrap").classList.remove("grid-loading");
                addCollectionItems(products, target);
                if (typeof window.addCollectionSpecificBanners === 'function') {
                    window.addCollectionSpecificBanners(collectionid);
                }
                sortCollectionWishlist()
            })
            .catch((error) => {
                displayNetworkError("error fetching from  api" + error)
                console.error(error);
            });
    });
}

function fetchSearchProducts() {
    const query = document.getElementById("page-search-query").value;
    let filtersString = '';
    let sortString = '';

    if (filters.length > 0) {
        // Convert filters to JSON string and adjust field names
        const filtersJson = JSON.stringify(filters)
            .replace(/"field":/g, 'field:')
            .replace(/"lte":/g, 'lte:')
            .replace(/"gte":/g, 'gte:')
            .replace(/"range":/g, 'range:')
            .replace(/"value":/g, 'value:');

        filtersString = `, filter: ${filtersJson}`;
    } else {
        // document.getElementById('nosto-filters-wrapper').style.display = 'none';
        // document.getElementById('nosto-search-active-filters').innerHTML = '';
    }

    if (currentSort.length > 0) {
        sortString = ",sort:" + JSON.stringify(currentSort)
            .replace(/"field":/g, 'field:')
            .replace(/"order":/g, 'order:')
            .replace(/"asc"/g, 'asc')
            .replace(/"desc"/g, 'desc');
    }

    const seeMoreButton = document.getElementById("search-see-more");
    const from = parseInt(seeMoreButton.getAttribute("data-page-loc"));
    nostojs(api => {
        api.search({
                query: query,
                products: {
                    fields: ["name", "price", "listPrice", "imageUrl", "url", "available", "tags1", "categories", "alternateImageUrls", "skus.id", "skus.name", "skus.availability", "skus.customFields.key", "skus.customFields.value", "customFields.key", "customFields.value"],
                    size: pageSize,
                    facets: ['*'],
                    filter: filters,
                    sort: currentSort,
                    from: from
                },
                keywords: {
                    fields: ["keyword"]
                }
            }, {
                track: 'serp',
            }).then(data => {
                console.log(data)
                if(data.redirect){
                    window.location.href = data.redirect
                }
                globData.facets = data.products.facets;
                globData.total = data.products.total
                const blurred = document.querySelectorAll('.nosto-blur'); // Fixed the typo
                blurred.forEach(item => { // Use forEach instead of each
                    item.classList.remove("nosto-blur"); // Remove the class from each item
                });


                sortFilters(data.products.facets, data.products.total);


                const loadingItems = document.querySelectorAll('.loading-grid-item');
                loadingItems.forEach(item => item.remove());
                let products = data.products.hits;
                products = products.filter((prod) => {
                    return !prod.name.toLowerCase().includes("mid-collection") && !prod.name.toLowerCase().includes("mid collection");
                });
                remLoadingProds();
                let target = document.getElementById("after-products");
                addCollectionItems(products, target, undefined, true);
            })
            .catch((error) => {
                console.error(error);
            });
    });
}

function fetchSearchPage() {
    const query = document.getElementById("page-search-query").value;
    let filtersString = '';
    let sortString = '';

    if (filters.length > 0) {
        // Convert filters to JSON string and adjust field names
        const filtersJson = JSON.stringify(filters)
            .replace(/"field":/g, 'field:')
            .replace(/"lte":/g, 'lte:')
            .replace(/"gte":/g, 'gte:')
            .replace(/"range":/g, 'range:')
            .replace(/"value":/g, 'value:');

        filtersString = `, filter: ${filtersJson}`;
    } else {
        // document.getElementById('nosto-filters-wrapper').style.display = 'none';
        // document.getElementById('nosto-search-active-filters').innerHTML = '';
    }

    if (currentSort.length > 0) {
        sortString = ",sort:" + JSON.stringify(currentSort)
            .replace(/"field":/g, 'field:')
            .replace(/"order":/g, 'order:')
            .replace(/"asc"/g, 'asc')
            .replace(/"desc"/g, 'desc');
    }
    const seeMoreButton = document.getElementById("search-see-more");
    const from = parseInt(seeMoreButton.getAttribute("data-page-loc"));
    nostojs(api => {
        api.search({
                query: query,
                products: {
                    fields: ["name", "price", "listPrice", "imageUrl", "url", "available", "tags1", "categories", "alternateImageUrls", "skus.id", "skus.name", "skus.availability", "skus.customFields.key", "skus.customFields.value", "customFields.key", "customFields.value"],
                    size: pageSize,
                    facets: ['*'],
                    filter: filters,
                    sort: currentSort,
                    from: from
                },
                keywords: {
                    fields: ["keyword"]
                }
            }, {
                track: 'category',
            }).then(data => {
                document.getElementById("search-see-more").classList.remove("see-more-loading")
                if (from + pageSize > data.products.total) {
                    document.getElementById("search-see-more").style.display = "none";
                }
                globData.facets = data.products.facets;
                globData.total = data.products.total
                const blurred = document.querySelectorAll('.nosto-blur'); // Fixed the typo
                blurred.forEach(item => { // Use forEach instead of each
                    item.classList.remove("nosto-blur"); // Remove the class from each item
                });

                sortFilters(data.products.facets, data.products.total);

                const loadingItems = document.querySelectorAll('.loading-grid-item');
                loadingItems.forEach(item => item.remove());
                let products = data.products.hits;
                products = products.filter((prod) => {
                    return !prod.name.toLowerCase().includes("mid-collection") && !prod.name.toLowerCase().includes("mid collection");
                });
                remLoadingProds();
                let target = document.getElementById("after-products");
                addCollectionItems(products, target, true);
            })
            .catch((error) => {
                console.error(error);
            });
    });
}

function sortFilters(facets, total) {
    document.getElementById("nosto-search-active-filters").innerHTML = "";
    // Loops through facets to split them into quantitative/qualitative facets
    // document.getElementById('nosto-results-filters').innerHTML = "";///////////////////
    for (let each of facets) {
        if (each.type === "stats") {
            createSlider(each, total);
        } else {
                createOption(each, total);
            
        }
    }
    const currentFacets = document.querySelectorAll(".filter-outer-wrapper");
    currentFacets.forEach((item)=>{
        const facetName = item.querySelector(".filter-option-dropdown")?.dataset.facetName;
        if(!facets.some((facet)=>{
            return facet.field == facetName;
        })){
            
            item.remove();
        }

    })
}

function handlise(input) {
    return input
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
}

const createOtherCard = (facet) => {
    facet.data.forEach(function(each) {
                    if (each.selected) {
                        document.querySelectorAll('.nosto-option-wrapper').forEach(function(optionWrapper) {
                            if (optionWrapper.dataset.optionValue === each.value) {
                                optionWrapper.querySelector('.facet-name').classList.add('active-filter');
                            }
                        });

                        const activeFilter = document.createElement('div');
                        activeFilter.setAttribute('data-facet-cat', facet.field);
                        activeFilter.setAttribute('data-filter-value', each.value);
                        activeFilter.textContent = each.value;
                        activeFilter.className = 'flex border border-solid border-gray-300 w-max rounded-full w-min px-2 nosto-active-filter nosto-active-filter-option text-xs py-2 h-min w-min';

                        const closeButton = document.createElement('span');
                        closeButton.textContent = 'x';
                        closeButton.className = 'ml-1 text-red-500';

                        activeFilter.appendChild(closeButton);
                        document.getElementById('nosto-search-active-filters').appendChild(activeFilter);
                    }
                });
}

// Creates filters from a facet
function createOption(each, total) {
    // Handles tags and prints as special cases
    if (each.field === "tags1") {
        createSizeOption(each, total);
    } else if (each.field === "customFields.custom-design") {
        createPrintOption(each);
    } else { // All other options
        createOtherCard(each);
        const classToAdd = each.name.replace(/ /g, "-") + "-filter-wrapper";
        const outerWrapper = document.createElement('div'); 
        outerWrapper.classList.add("filter-outer-wrapper");

        const dropdown = document.createElement('div');
        dropdown.textContent = translations.collection.filters[each.name.toLowerCase().replace(" ", "_").replace("&", "and")] || each.name;
        dropdown.classList.add("filter-option-dropdown", "px-5", "py-4", "border-solid", "border-gray-200", "py-2", "shrink-0", "text-xs", "uppercase", "text-black", "border-t", classToAdd);
        dropdown.setAttribute("data-facet-name", each.field);

        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.setAttribute("class", "size-4 shrink-0 rotate-180 rotatable absolute right-2");
        svg.setAttribute("width", "24");
        svg.setAttribute("height", "24");
        svg.setAttribute("viewBox", "0 0 24 24");
        svg.setAttribute("fill", "none");
        svg.setAttribute("stroke", "currentColor");
        svg.setAttribute("stroke-width", "2");
        svg.setAttribute("stroke-linecap", "round");
        svg.setAttribute("stroke-linejoin", "round");

        const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
        path.setAttribute("d", "m18 15-6-6-6 6");
        svg.appendChild(path);
        dropdown.appendChild(svg);

        const inner_wrapper = document.createElement('div');
        inner_wrapper.classList.add("nosto-wrapper", "w-full", "grid", "border-b", "border-solid", "border-gray-200", "px-5", "pb-5", "gap-2");
        inner_wrapper.setAttribute("data-filter-type", each.field);
        inner_wrapper.style.display = "none";
        const prevSelector = "." + classToAdd;
        const prevWrapper = document.querySelector(prevSelector)
        if(prevWrapper){
            const oldFilters = prevWrapper.closest(".filter-outer-wrapper").querySelector(".nosto-wrapper");
            oldFilters.remove();
            const prevDisplay = oldFilters.style.display
            prevWrapper.insertAdjacentElement("afterend", inner_wrapper);
            inner_wrapper.style.display = prevDisplay
        }else{

            outerWrapper.append(dropdown, inner_wrapper);
        }

        each.data.forEach(option => {
            let ismid = option.value === "Mid-Collection Banners";
            const opWrapper = document.createElement('a');
            let url = window.location.href + "/" + handlise(each.name + " " + option.value);

            opWrapper.href = url;
            opWrapper.classList.add("nosto-option-wrapper", "flex", "relative", "px-2");
            opWrapper.setAttribute("data-option-value", option.value.toString());
            const name = document.createElement('div');
            name.textContent = translations.collection.filters[option.value.toLowerCase().replace(" ", "_").replace("&", "and")] || option.value;
            name.classList.add("relative", "facet-name", "py-2", "rounded-md", "border", "border-gray-300", "border-solid", "w-full", "text-center", "text-sm");
            if(option.selected){
                name.classList.add("active-filter");

            }

            const count = document.createElement('div');
            count.textContent = `(${option.count})`;
            count.classList.add("text-xxs", "facet-count", "absolute");

            name.appendChild(count);
            opWrapper.appendChild(name);

            if (!ismid) {
                inner_wrapper.appendChild(opWrapper);
            }
        });

        document.getElementById('nosto-results-filters').appendChild(outerWrapper);
    }
}

function createSlider(each) { // Creates a slider for price with all functions to handle updating the filter
    const priceSlider = document.querySelector(".price-filter-wrapper");
    if(priceSlider) return;
    each.min = 5;
    each.max = Math.ceil(each.max / 5) * 5;

    const outerWrapper = document.createElement('div');
    outerWrapper.classList.add("filter-outer-wrapper", "price-filter-wrapper");

    const dropdown = document.createElement('div');
    dropdown.textContent = translations.collection.filters[each.name.toLowerCase().replace(" ", "_").replace("&", "and")] || each.name;
    dropdown.classList.add("filter-option-dropdown", "px-5", "py-4", "border-solid", "border-gray-200", "py-2", "shrink-0", "text-xs", "uppercase", "text-black", "border-t");
    dropdown.setAttribute("data-facet-name", each.field);

    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("class", "size-4 shrink-0 rotate-180 rotatable absolute right-2");
    svg.setAttribute("width", "24");
    svg.setAttribute("height", "24");
    svg.setAttribute("viewBox", "0 0 24 24");
    svg.setAttribute("fill", "none");
    svg.setAttribute("stroke", "currentColor");
    svg.setAttribute("stroke-width", "2");
    svg.setAttribute("stroke-linecap", "round");
    svg.setAttribute("stroke-linejoin", "round");

    const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("d", "m18 15-6-6-6 6");
    svg.appendChild(path);
    dropdown.appendChild(svg);

    const inner_wrapper = document.createElement('div');
    inner_wrapper.classList.add("nosto-wrapper", "px-5", "py-4", "pb-6", "my-2", "mb-3", "px-5", "pb-5", "gap-2");
    inner_wrapper.setAttribute("data-filter-type", each.field);
    inner_wrapper.style.display = "none";

    outerWrapper.append(dropdown, inner_wrapper);

    const header = document.createElement('header');
    header.classList.add("nosto-header");
    const title = document.createElement('h2');
    title.textContent = "Price Range";
    const subtitle = document.createElement('p');
    subtitle.textContent = "Use slider to change price range";
    header.append(title, subtitle);

    // Create price input fields
    const priceInput = document.createElement('div');
    priceInput.classList.add("nosto-price-input", "hidden");
    priceInput.style.display = "none";

    const minField = document.createElement('div');
    minField.classList.add("nosto-field");
    const minLabel = document.createElement('span');
    minLabel.textContent = "Min";
    const minInput = document.createElement('input');
    minInput.setAttribute('type', 'number');
    minInput.classList.add('nosto-input-min');
    minInput.value = each.min;

    minField.append(minLabel, minInput);

    const separator = document.createElement('div');
    separator.classList.add("nosto-separator");
    separator.textContent = '-';

    const maxField = document.createElement('div');
    maxField.classList.add("nosto-field");
    const maxLabel = document.createElement('span');
    maxLabel.textContent = "Max";
    const maxInput = document.createElement('input');
    maxInput.setAttribute('type', 'number');
    maxInput.classList.add('nosto-input-max');
    maxInput.value = each.max;

    maxField.append(maxLabel, maxInput);

    priceInput.append(minField, separator, maxField);

    // Create slider and range inputs
    const slider = document.createElement('div');
    slider.classList.add("nosto-slider");

    const progress = document.createElement('div');
    progress.classList.add("nosto-progress");
    slider.appendChild(progress);

    // Min/Max indicators
    const minIndicator = document.createElement('div');
    minIndicator.classList.add("nosto-indicator", "min-indicator", "absolute", "left-0", "top-full");
    minIndicator.textContent = GEBO.settings.shop_money_format.replace(/\{\{.*?\}\}/, each.min)

    const maxIndicator = document.createElement('div');
    maxIndicator.classList.add("nosto-indicator", "max-indicator", "absolute", "right-0", "top-full");
    maxIndicator.textContent = GEBO.settings.shop_money_format.replace(/\{\{.*?\}\}/, each.max)

    progress.append(minIndicator, maxIndicator);

    const rangeInput = document.createElement('div');
    rangeInput.classList.add("nosto-range-input");

    const minRange = document.createElement('input');
    minRange.setAttribute('type', 'range');
    minRange.classList.add('nosto-range-min');
    minRange.min = each.min;
    minRange.max = each.max;
    minRange.value = each.min;
    minRange.step = 1;

    const maxRange = document.createElement('input');
    maxRange.setAttribute('type', 'range');
    maxRange.classList.add('nosto-range-max');
    maxRange.min = each.min;
    maxRange.max = each.max;
    maxRange.value = each.max;
    maxRange.step = 1;

    rangeInput.append(minRange, maxRange);

    // Append everything to the wrapper
    inner_wrapper.append(priceInput, slider, rangeInput);
    document.getElementById('nosto-results-filters').prepend(outerWrapper);

    // Function to update the slider's visual state
    function updateSlider(isInputChange) {
        const min = Math.floor(parseInt(minRange.value, 10));
        const max = Math.ceil(parseInt(maxRange.value, 10));

        if (min > max) {
            minRange.value = max;
        }

        if (max < min) {
            maxRange.value = min;
        }

        minInput.value = minRange.value;
        maxInput.value = maxRange.value;

        const minPercent = ((min - each.min) / (each.max - each.min)) * 100;
        const maxPercent = ((max - each.min) / (each.max - each.min)) * 100;

        progress.style.left = minPercent + '%';
        progress.style.width = (maxPercent - minPercent) + '%';

        minIndicator.textContent = GEBO.settings.shop_money_format.replace(/\{\{.*?\}\}/, minRange.value)
        maxIndicator.textContent = GEBO.settings.shop_money_format.replace(/\{\{.*?\}\}/, maxRange.min)

        // Call the debounced function to handle filter updates
        if (isInputChange) {
            debouncedUpdateFilter(min, max);
        }
    }

    const debouncedUpdateFilter = debounce(function(min, max) {
        min = Math.floor(min);
        max = Math.ceil(max);
        const newFilter = {
            "field": "price",
            "range": {
                gte: `${min}`,
                lte: `${max}`
            }
        };

        filterSearch(newFilter);
    }, 300); // 300 ms debounce delay for filter updates

    // Event listeners for range inputs
    minRange.addEventListener('input', function() {
        updateSlider(true);
    });

    maxRange.addEventListener('input', function() {
        updateSlider(true);
    });

    // Initialize the slider
    updateSlider(false);
}

// Debounce function
function debounce(func, delay) {
    let timeout;
    return function(...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), delay);
    };
}

// Create the size filters in the sidebar from size tags
function createSizeOption(data) {
    createSizeCard(data)
    const sizeSet = new Set();
    for (const values of sizeMap.values()) {
        values.forEach(value => sizeSet.add(value));
    }

    const size_tags = data.data.filter(function(tag) {
        return sizeSet.has(tag.value);
    });
    const outerWrapper = document.createElement('div');
    outerWrapper.classList.add("filter-outer-wrapper");
    
    const dropdown = document.createElement('div');
    dropdown.textContent = translations.collection.filters.size || "size"
    dropdown.classList.add("filter-option-dropdown", "px-5", "py-4", "border-solid", "border-gray-200", "py-2", "shrink-0", "text-xs", "uppercase", "text-black", "border-t", "size-filter-wrapper");
    dropdown.setAttribute("data-facet-name", data.field);
    
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("class", "size-4 shrink-0 rotate-180 rotatable absolute right-2");
    svg.setAttribute("width", "24");
    svg.setAttribute("height", "24");
    svg.setAttribute("viewBox", "0 0 24 24");
    svg.setAttribute("fill", "none");
    svg.setAttribute("stroke", "currentColor");
    svg.setAttribute("stroke-width", "2");
    svg.setAttribute("stroke-linecap", "round");
    svg.setAttribute("stroke-linejoin", "round");
    
    const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("d", "m18 15-6-6-6 6");
    svg.appendChild(path);
    dropdown.appendChild(svg);
    
    const inner_wrapper = document.createElement('div');
    inner_wrapper.classList.add("nosto-wrapper", "w-full", "grid", "px-5", "pb-5", "gap-2", "relative", "grid", "border-solid", "border-gray-200", "grid-cols-4");
    inner_wrapper.setAttribute("data-filter-type", data.field);
    inner_wrapper.style.display = "none";
    
    const prevWrapper = document.querySelector(".size-filter-wrapper");

    if(prevWrapper){
        const oldFilters = prevWrapper.closest(".filter-outer-wrapper").querySelector(".nosto-wrapper");
            oldFilters.remove();
        const prevDisplay = oldFilters.style.display
            prevWrapper.insertAdjacentElement("afterend", inner_wrapper);
            inner_wrapper.style.display = prevDisplay
    }else{
        outerWrapper.append(dropdown, inner_wrapper);
        document.getElementById('nosto-results-filters').appendChild(outerWrapper);
    }

    for (const [key, values] of sizeMap.entries()) {
        let max_val = 0;
        const filters = [];
        let humanReadable = key.replace(/\b\w/g, char => char.toUpperCase());
        let active = false;
        for (const each of size_tags) {
            if (values.includes(each.value)) {
                if(each.selected){
                    active = true
                }
                max_val = Math.max(max_val, each.count);
                filters.push(each.value);
                
            }
        }
        const opWrapper = document.createElement('a');
        let url = window.location.href + "/" + handlise("size" + " " + humanReadable);
        opWrapper.href = url;
        opWrapper.classList.add("nosto-option-wrapper", "flex", "relative", "py-1");
        opWrapper.setAttribute("data-option-value", filters.join(', '));

        const name = document.createElement('div');
        name.textContent = humanReadable;
        name.classList.add("facet-name", "py-4", "text-center", "items-center", "justify-center", "flex", "rounded-md", "relative", "border", "border-gray-300", "border-solid", "w-full", "text-center", "text-xs", "text-gray-600", "relative");
        if(active){
            name.classList.add("active-filter")
            
        }
        const count = document.createElement('div');
        count.textContent = `(${max_val})`;
        count.classList.add("text-xxs", "facet-count", "absolute");

        name.appendChild(count);
        opWrapper.appendChild(name);

        if (max_val !== 0) {
            inner_wrapper.appendChild(opWrapper);
        }
    }
}

function createPrintOption(data) {
    createPrintCard(data);
    let added = false;
    const outerWrapper = document.createElement('div');
    outerWrapper.classList.add("filter-outer-wrapper");

    const dropdown = document.createElement('div');
    dropdown.textContent = translations.collection.filters.print || "print";
    dropdown.classList.add("filter-option-dropdown", "px-5", "py-4", "border-solid", "border-gray-200", "py-2", "shrink-0", "text-xs", "uppercase", "text-black", "border-t", "filter-print-wrapper");
    dropdown.setAttribute("data-facet-name", data.field);

    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("class", "size-4 shrink-0 rotate-180 rotatable absolute right-2");
    svg.setAttribute("width", "24");
    svg.setAttribute("height", "24");
    svg.setAttribute("viewBox", "0 0 24 24");
    svg.setAttribute("fill", "none");
    svg.setAttribute("stroke", "currentColor");
    svg.setAttribute("stroke-width", "2");
    svg.setAttribute("stroke-linecap", "round");
    svg.setAttribute("stroke-linejoin", "round");

    const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("d", "m18 15-6-6-6 6");
    svg.appendChild(path);
    dropdown.appendChild(svg);

    const inner_wrapper = document.createElement('div');
    inner_wrapper.classList.add("nosto-wrapper", "w-full", "grid", "px-5", "pb-5", "gap-2", "relative", "grid", "border-solid", "border-gray-200", "grid-cols-4");
    inner_wrapper.setAttribute("data-filter-type", data.field);
    inner_wrapper.style.display = "none";

    
    const styleTagArr = [];
    for (const tag of data.data) {
        styleTagArr.push(tag);
    }
    for (const globPrint of glob_designs) {
        let current_tag = globPrint.tag;
        let current_url = globPrint.img_url;
        let current_title = globPrint.title;
        
        for (const tagPrint of styleTagArr) {
            if (tagPrint.value.replace("design-", "") === current_tag) {
                const opWrapper = document.createElement('div');
                opWrapper.classList.add("nosto-option-wrapper", "flex", "relative", "rounded-full", "flex-col", "items-center", "justify-between", "py-4");
                opWrapper.setAttribute("data-option-value", tagPrint.value);
                
                const img = document.createElement('img');
                img.classList.add("rounded-full");
                img.setAttribute("src", current_url);
                
                const padding = document.createElement('div');
                padding.classList.add("w-full");
                padding.style.padding = "100% 0 0 0";
                
                const title = document.createElement('div');
                title.textContent = current_title;
                title.classList.add("text-xs", "mt-2", "text-center", "h-full", "flex", "items-center", "facet-name", "px-1", "rounded-md");
                
                if(tagPrint.selected){
                    title.classList.add("active-filter")
                }
                
                const count = document.createElement('div');
                count.textContent = `(${tagPrint.count})`;
                count.classList.add("text-xxs", "facet-count", "absolute");
                
                opWrapper.append(img, title, count);
                inner_wrapper.appendChild(opWrapper);
                added = true;
            }
        }
    }
    const prevWrapper = document.querySelector(".filter-print-wrapper");
    if (added) {
        if(prevWrapper){
            const oldFilters = prevWrapper.closest(".filter-outer-wrapper").querySelector(".nosto-wrapper");
            oldFilters.remove();
                const prevDisplay = oldFilters.style.display
            prevWrapper.insertAdjacentElement("afterend", inner_wrapper);
            inner_wrapper.style.display = prevDisplay
        }else{

            document.getElementById('nosto-results-filters').appendChild(outerWrapper);
                outerWrapper.append(dropdown, inner_wrapper);
            }
    }
}

// Called when clicking an active filter to remove, removes that filter from the array and calls fetchProducts
//@param field: the field the filter is removed from, tags1, product_type etc...
//@param value: the value from the field to be removed
function remFilterSearch(field, value, shouldRefresh = true) {

    const prevSelectedPopularFilter = document.querySelector(`.collection-fiter-dropdown-option[data-filter-type='${field}'][data-filter-value='${value}']`)
    if(prevSelectedPopularFilter){
        prevSelectedPopularFilter.querySelector("input").checked = false;
    }
    if (value.includes(",")) {
        value = value.split(",").map(v => v.trim());
    } else {
        value = [value];
    }

    const updatedFilters = filters.map(filter => {
        if (filter.field === field) {
            if (Array.isArray(filter.value)) {
                const updatedValues = filter.value.filter(v => !value.includes(v));
                if (updatedValues.length === 0) {
                    return null;
                }
                return {
                    ...filter,
                    value: updatedValues
                };
            } else if (value.includes(filter.value)) {
                return null;
            }
        }
        return filter;
    }).filter(filter => filter !== null);

    filters = updatedFilters;

    const currentUrl = window.location.href.split('?')[0];
    const newParams = new URLSearchParams(window.location.search);

    value.forEach(val => {
        const paramKey = `filter-${field}`;
        const paramValues = newParams.getAll(paramKey);
        const newParamValues = paramValues.filter(v => v !== val);
        if (newParamValues.length === 0) {
            newParams.delete(paramKey);
        } else {
            newParams.set(paramKey, newParamValues);
        }
    });

    const newUrl = `${currentUrl}?${newParams.toString()}`;

    window.history.replaceState(null, "", newUrl);
    if(shouldRefresh){

        if (searchPageInput) {
            let query = searchPageInput.value;
            fetchSearchProducts(query);
        } else {
            fetchCollProducts();
        }
    }
}


const resetFilters = () => {
    const currentUrl = window.location.href.split('?')[0];
    window.history.replaceState(null, "", currentUrl);

    filters = [];
    if (searchPageInput) { //get products for search
        let query = searchPageInput.value;
        fetchSearchProducts(query);
    } else {
        fetchCollProducts(); // Get products on collection load
    }
}


function remLoadingProds() {
    const loadingProds = document.querySelectorAll('.loading-prod');
    loadingProds.forEach(item => {
        item.remove();
    })
}

function getShopifyProductHandle(url) {
    if (!url) {
        return null;
    }

    try {
        // Remove any query parameters
        const urlWithoutParams = url.split('?')[0];
        // Split by '/' and get the last segment
        const segments = urlWithoutParams.split('/');
        const handle = segments[segments.length - 1];

        //debug.log('Extracted handle:', handle);
        return handle;
    } catch (error) {
        //debug.error('Error extracting handle:', error);
        return null;
    }
}

// const market = document.body.getAttribute("market") === 'gb' ? 'uk' : document.body.getAttribute("market");
// const marketTag = `country-${market}`;
const market = document.body.getAttribute("market") === 'gb' ? 'uk' : document.body.getAttribute("market");
const marketTag = `country-${market}`;

function restoreBanners(bannerMap) {
    let count = 0
    bannerMap.forEach(({
        parent,
        index
    }, banner) => {
        if (parent) {
            const children = Array.from(parent.children);
            if (index >= children.length) {
                parent.append(banner);
            } else {
                parent.insertBefore(banner, children[index - count]);
                count += 1;
            }
        }
    });
}
const heartSvg = `<img style="height:40px;width:50px" src="https://cdn.shopify.com/s/files/1/0353/7249/files/Heart_FILL_1.png?v=1761659296">`





// const generateProductHtml = (product, index, currentMonth, searchPage, target) => {
//     try {
//         product.price = (product.price) / 100 * equivelant100;
//         if (is_sale) {
//             const saleTag = product.tags1.find((tag) => {
//                 return tag.includes("lw-")
//             })
//             let saleAmount = Number(saleTag?.split("-").pop()) || 0;

//             product.price = product.price * (1 - (saleAmount / 100));
//         }
//         const flashSaleObj = product.customFields.find((field)=>{
//             return field.key == "custom-flash_sale"
//         })?.value
//         const flashSaleListObj = product.customFields.find((field)=>{
//             return field.key == "custom-flash_sale_list"
//         })?.value
//         product.listPrice = (product.listPrice) / 100 * equivelant100
//         let proceed = product.available || product.tags1.includes("show-out-of-stock-sold-out") || product.tags1.includes("sock-option-bundle");
//         const collectionHandle = document.getElementById("coll-handle")?.value;
//         const showInCollectionTag = product.tags1.find((tag)=>{
//             return tag.includes("show-in-collection-")
//         })
//         const toShowInCollection = product.tags1.some((tag)=>{
//             return tag == "show-in-collection"
//         })
//         const showInCollection = toShowInCollection? showInCollectionTag.includes(collectionHandle) : false;   
//         let hideMeProceed = !product.tags1.includes("hide-me") || (showInCollection && !searchPage)  //1234
//         proceed = proceed && hideMeProceed &&
//             (product.tags1.includes(marketTag) || !product.tags1.some(tag => tag.startsWith("country-")));

//         if (product.alternateImageUrls) {
//             product.alternateImageUrls.unshift(product.imageUrl);
//         }
//         const tempProdImages = product.alternateImageUrls ? product.alternateImageUrls : [product.imageUrl];

//         let prodImages = tempProdImages.filter((url) => {
//             let toReturn = true;
//             let matchString = ("month-" + currentMonth);
//             toReturn = url.toLowerCase().includes("month-") ? url.toLowerCase().includes(matchString) : true;
//             toReturn = toReturn && (url.toLowerCase().includes("sub-") ? url.toLowerCase().includes("sub-collection") : true);
//             return toReturn;
//         });
//         if (!product.name.toLowerCase().includes('mid-collection') && !product.name.toLowerCase().includes('mid collection') && proceed) {
//             const productCard = document.createElement('div');
//             // Add unique identifier using product ID
//             productCard.setAttribute('data-product-id', product.productId);
//             productCard.classList.add("product-card", "flex", "flex-col");
//             if(flashSaleObj || flashSaleListObj){
//                 productCard.classList.add("flash-sale-product")
//             }
//             let tags = product.tags1;
//             if (tags.includes("design-cookie-monster") && false) {
//                 productCard.classList.add("cookie-monster-product")
//             }
//             //card_index+=;
//             const imageWrapper = document.createElement('div');
//             imageWrapper.classList.add("product-card__image-wrapper");
//             const isPrepaid = product.name.toLowerCase().includes("prepaid");
//             if(isPrepaid){
//                 const match = product.name.toLowerCase().match(/\b\d{1,2}\s+months?\s+prepaid\b/i);
//                 const result = match ? match[0] : null;
//                 const roundel = document.createElement("div");
//                 roundel.className = "absolute bottom-0 left-0 flex items-center justify-center text-xs p-2 font-bold prepaid-roundel text-center capitalize";
//                 roundel.style.background="#000";
//                 roundel.style.color = "#f00f83";
//                 roundel.style.borderRadius = "0 0.305rem 0 0";
//                 roundel.style.zIndex = "1";
//                 roundel.style.maxWidth = "40%";
//                 roundel.innerHTML = result;
//                 imageWrapper.appendChild(roundel);
//             }
//             const isSuperbowl = product.tags1.includes("super-bowl-60");
//             if(isSuperbowl){
//                 const roundel = document.createElement("div");
//                 roundel.className = "absolute bottom-0 left-0 text-white flex items-center justify-center text-xs p-2 font-bold prepaid-roundel text-center capitalize";
//                 roundel.style.background="#c6cacc";
//                 roundel.style.borderRadius = "0 0.305rem 0 0";
//                 roundel.style.zIndex = "1";
//                 roundel.style.maxWidth = "40%";
//                 roundel.innerHTML = "Super Bowl LX";
//                 imageWrapper.appendChild(roundel);
//             }
            

//             const prodContainer = document.createElement("div");
//             prodContainer.className = "prod-container";

//             const paddingEle = document.createElement("div");
//             paddingEle.className = "image-placeholder bg-gray-100"

//             const productLink = document.createElement('a');
//             productLink.id = "collection-product-link-" + (index + 1)
//             productLink.draggable = false;
//             let linkToUse = product.url.replace("https://www.myoddballs.com", "");
//             if(countryIso != "GB"){
//                 linkToUse = linkToUse.includes("?") ? linkToUse + `&country=${countryIso}` : linkToUse + `?country=${countryIso}`;
//             }
//             productLink.href = linkToUse;
//             productLink.classList.add("product-image-outer-wrapper");
            
            

            
//             let imagesToUse = prodImages.slice(0,2);
//             let loading = index > 3  ? "loading" : "";

//             imagesToUse.forEach((image, index)=>{
//                 const imgWrapper = document.createElement("div");
//                 imgWrapper.className = "grid-image-wrapper"
//                 const imgEle = document.createElement("img")
//                 imgEle.draggable = false;
//                 imgEle.loading = index == 0 && loading == "" ? "" : "lazy";
//                 imgEle.src = image 
//                 imgEle.srcset = modifyUrlWithResolutions(image);
//                 imgWrapper.append(imgEle);
//                 productLink.append(imgWrapper)
//             })

//             let desktopDotsWrapper = document.createElement("div");
//             desktopDotsWrapper.className = "desktop-dots-wrapper"
//             for(let i =0; i<imagesToUse.length; i++) {
//                 let dot = document.createElement("div");
//                 dot.className = "grid-swiper-dot";
//                 let dotOuter = document.createElement("div");
//                 dotOuter.className = "dot-outer"
//                 if(i == 0){
//                     dot.classList.add("active")
//                 }
//                 dot.dataset.index = i;
//                 dot.append(dotOuter);
//                 desktopDotsWrapper.append(dot);
//             }
//             prodContainer.append(desktopDotsWrapper);

//             prodContainer.append(paddingEle, productLink)
//             imageWrapper.appendChild(prodContainer);

//             const labelLoc = document.createElement('div');
//             labelLoc.className = "label-loc";
//             labelLoc.classList.add("text-xxs");
//             productCard.appendChild(imageWrapper);
//             productCard.appendChild(labelLoc);

//             // Quick add button
//             const quickAddWrapper = document.createElement('div');
//             quickAddWrapper.className = "bg-gray-100 justify-center p-3";
//             const quickAddDiv = document.createElement('div');
//             const bisSignup = document.createElement('div');
//             bisSignup.className = "rounded-full border border-black border-solid flex justify-center items-center text-center w-full bg-white sm:max-w-[90%] mx-auto py-2 text-xxs md:text-xs klaviyo-bis-trigger uppercase";
//             bisSignup.innerHTML = "Sign up to back in stock"
//             if (product.available || product.tags1.includes("sock-option-bundle")|| product.tags1.includes("mixed-material-bundle")) {
//                 quickAddWrapper.append(quickAddDiv);
//             } else {
//                 quickAddWrapper.append(bisSignup);
//             }
//             quickAddDiv.className = "rounded-full border border-black border-solid grid grid-cols-2 w-full bg-white sm:max-w-[90%] mx-auto";

//             let gridType = (searchPage) ? "search-page-" : "collection-";

//             const seeMoreDiv = document.createElement('a');
//             seeMoreDiv.id = gridType + "see-more-" + (index + 1)
//             seeMoreDiv.href = linkToUse;
//             seeMoreDiv.className = "text-xxs md:text-xs items-center text-center uppercase border-r border-solid border-gray-300 py-2 md:py-2 font-semibold md:font-normal";
//             seeMoreDiv.innerText = translations.collections.see_more;
//             quickAddDiv.append(seeMoreDiv);

//             const quickAddLoader = document.createElement('div');
//             quickAddLoader.className = "w-4 quick-buy-loader";
//             quickAddLoader.innerHTML = GEBO.helpers.loader;

//             const quickAddButton = document.createElement('div');
//             quickAddButton.id = gridType + "quick-buy-" + (index + 1)
//             quickAddButton.className = "event-quickbuy-show quick-add-wrapper text-xxs md:text-xs items-center text-center uppercase coll-quick-add py-2 font-semibold md:font-normal relative md:py-2 flex justify-center";
//             quickAddButton.setAttribute('data-cro-feature-clicked', 'grid-item-quick-buy');
//             const quickBuyDiv = document.createElement('div');
//             quickBuyDiv.className = "quick-buy-text";
//             quickBuyDiv.innerHTML = translations.collections.quick_buy;
//             quickBuyDiv.setAttribute('data-cro-feature-clicked', 'grid-item-quick-buy');
//             quickAddButton.append(quickBuyDiv);

//             // Create padding div and append it correctly
//             const qbPadding = document.createElement('div');
//             qbPadding.className = "absolute left-0 coll-quick-add z-2";
//             qbPadding.style.top = "-50%";
//             qbPadding.style.width = "120%";
//             qbPadding.style.height = "195%";
//             qbPadding.setAttribute('data-handle', getShopifyProductHandle(product.url));
//             qbPadding.setAttribute('data-cro-feature-clicked', 'grid-item-quick-buy');
//             quickAddButton.append(qbPadding);
//             quickAddButton.append(quickAddLoader);
//             quickAddDiv.append(quickAddButton);

//             // Product details
//             const productDetails = document.createElement('div');
//             productDetails.append(quickAddWrapper);
//             productDetails.classList.add("product-card__details", "sm:px-0", "h-full", "pb-2");

//             const productTitleLink = document.createElement('a');
//             productTitleLink.id = "collection-product-title-" + (index + 1)
//             productTitleLink.classList.add("h-full", "flex", "flex-col", "justify-between");
//             productTitleLink.href = linkToUse;

//             let titleInfo = titleLogic(product);

//             const productTitle = document.createElement('p');
//             productTitle.classList.add("product-card__details__title", "px-2", "font-semibold", "flex");
//             const titleEleWithHeart = document.createElement("div")
//             titleEleWithHeart.textContent = String(titleInfo['cleanTitle']);
//             titleEleWithHeart.style.width="0px";
//             titleEleWithHeart.style.flexGrow="1";

//             const heartSvgEleWrapper = document.createElement("div");
//             heartSvgEleWrapper.classList.add("wishlist-wrapper")
//             heartSvgEleWrapper.style.height="40px";
//             heartSvgEleWrapper.style.width="50px";
//             heartSvgEleWrapper.style.position="relative";
//             const heartSvgEle = document.createElement("div");
//             heartSvgEleWrapper.appendChild(heartSvgEle)
//             heartSvgEle.className = "collection-wishlist-trigger w-full h-full";
//             heartSvgEle.dataset.id = product.productId
//             heartSvgEle.innerHTML = heartSvg;
//             productTitle.append(titleEleWithHeart, heartSvgEleWrapper);

//             const productTitleWrap = document.createElement('div');

//             const productCategory = document.createElement('p');
//             productCategory.classList.add("product-card__details__color", "px-2");
//             productCategory.textContent = String(titleInfo['subTitle']);

            
//             const productPrice = document.createElement('p');
//             if(flashSaleObj || flashSaleListObj){
//                 productPrice.classList.add("animate-mt")
//             }
//             productPrice.classList.add("product-card__details__price", "px-2", "text-magenta-500", "text-md");
//             let price = product.price;
//             let listPrice = product.listPrice;
//             if (listPrice % 1 !== 0) {
//                 listPrice = parseFloat(listPrice).toFixed(2);
//             }
//             if (price % 1 !== 0) {
//                 price = parseFloat(price).toFixed(2);
//             }
//             const normalPrice = GEBO.settings.shop_money_format.replace(/\{\{.*?\}\}/, price);
//             const listPriceElement = product.listPrice > product.price ?
//                 `<del class="ml-1 text-gray-400">${GEBO.settings.shop_money_format.replace(/\{\{.*?\}\}/, listPrice)}</del>` :
//                 `<del class="ml-1 text-gray-400 hidden">${GEBO.settings.shop_money_format.replace(/\{\{.*?\}\}/, listPrice)}</del>`;
//             productPrice.innerHTML = `${normalPrice}${listPriceElement}`;

//             const productPriceWrap = document.createElement('div');

//             productTitleWrap.append(productTitle, productCategory);
//             productPriceWrap.append(productPrice);
//             productTitleLink.append(productTitleWrap, productPriceWrap);
//             if(flashSaleListObj){

//                 const flashSaleEl = createFlashSaleProdList(product, productTitleLink)
//                 productTitleLink.insertBefore(flashSaleEl, productPriceWrap);
//             }
//             else if(flashSaleObj){
//                  const flashSaleEl = createFlashSaleProd(product, productTitleLink)
//                  productTitleLink.insertBefore(flashSaleEl, productPriceWrap);
//             }

//             productDetails.appendChild(productTitleLink);
//             productCard.appendChild(productDetails);

//             const prodInfo = document.createElement('input');
//             prodInfo.setAttribute("type", "hidden");
//             prodInfo.setAttribute("value", JSON.stringify(product));
//             prodInfo.classList.add("prod-info");
//             productCard.appendChild(prodInfo);
//             //christmas message
//             const christmas_banner_element = document.getElementById('christmas_banner_metaobject_collection');
//             if (christmas_banner_element && !product.name.toLowerCase().includes("subscription")) {
//                 const christmasWrapper = document.createElement("div");
//                 christmasWrapper.innerHTML = christmas_banner_element.innerHTML;
//                 productCard.appendChild(christmasWrapper);
//             }
//             target.append(productCard);
//         } else if ((product.name.toLowerCase().includes('mid-collection') || product.name.toLowerCase().includes('mid collection')) && tagsProceed) {
//             const bannerUrl = product.customFields.find(field => field.key === 'custom-collection_mid_banner_url')?.value;
//             const wrapper_wrapper = document.createElement('div');
//             const wrapper = document.createElement('div');
//             wrapper.classList.add('group', 'relative', 'justify-center', 'bg-white', 'flex', 'flex-col', 'gap-0.5', "w-full", "h-full");
//             wrapper.setAttribute('data-handle', product.handle);
//             if (product.tags1.includes("feature-shoppable")) {
//                 wrapper.classList.add('mcb');
//             }
//             wrapper.classList.add('mid-collection-banner');
//             const padding = document.createElement('div');
//             padding.classList.add('w-full', 'pt-full');
//             let mobileUrl;
//             let desktopUrl;
//             for (image of prodImages) {
//                 if (image.toLowerCase().includes("desktop")) {
//                     desktopUrl = image;
//                 }
//                 if (image.toLowerCase().includes("mobile")) {
//                     mobileUrl = image;
//                 }
//             }
//             const mobileImg = document.createElement('img');
//             mobileImg.srcset = modifyUrlWithResolutions(mobileUrl);
//             mobileImg.setAttribute('src', mobileUrl);
//             mobileImg.classList.add('px-3', 'py-1', 'absolute', 'h-full', 'object-cover', "mobile-mcb");
//             mobileImg.style.left = "50%";
//             mobileImg.style.transform = "translateX(-50%)";
//             wrapper.appendChild(padding);
//             wrapper.appendChild(mobileImg);
//             const desktopImg = document.createElement('img');
//             desktopImg.srcset = modifyUrlWithResolutions(desktopUrl);
//             desktopImg.setAttribute('src', desktopUrl);
//             desktopImg.classList.add('px-3', 'py-1', 'absolute', 'h-full', 'object-cover', "desktop-mcb");
//             desktopImg.style.left = "50%";
//             desktopImg.style.transform = "translateX(-50%)";
//             wrapper.appendChild(padding);
//             wrapper.appendChild(desktopImg);
//             wrapper_wrapper.appendChild(wrapper);
//             target.append(wrapper_wrapper);


//             // element that will be wrapped in bannerUrl
//             if (bannerUrl) {
//                 topWrapper = document.createElement('a');
//                 topWrapper.setAttribute('href', bannerUrl.replace("https://www.myoddballs.com", "")); // Set the href to the bannerUrl

//                 // insert wrapper before el in the DOM tree
//                 wrapper.parentNode.insertBefore(topWrapper, wrapper);

//                 // move el into wrapper
//                 topWrapper.appendChild(wrapper);
//             }

//         }

//     } catch (error) {
//         console.error("Error adding: " + product.name);
//         console.error("Error: " + error);
//     }
// }
let midCollectionBanners
async function addCollectionItems(products, target, isPage = false, searchPage = false) {
    let bannerMap = new Map();
    if (!isPage) {
        midCollectionBanners = document.querySelectorAll(".nosto_element.product-card");

        // Store the original parent and index
        midCollectionBanners.forEach((banner) => {
            const parent = banner.closest("#AjaxinateContainer");
            if (parent) {
                const index = Array.from(parent.children).indexOf(banner);
                bannerMap.set(banner, {
                    parent,
                    index
                });
            }
        });


        target.innerHTML = "";

    }

    if (products.length == 0) {
        if (!isPage) {
            const oosWrapper = document.createElement("div");
            oosWrapper.className = "w-full h-full flex items-center justify-center flex-col col-span-2 my-8 md:col-span-4";
            const oosMessage = document.createElement("div");
            oosMessage.innerHTML = "No results for these filters";
            const resetButton = document.createElement("div");
            resetButton.className = "button js-reset-filters";
            resetButton.innerHTML = "Reset Filters";
            oosWrapper.append(oosMessage, resetButton)
            target.append(oosWrapper);
        }

    }

    if (products.length < pageSize) {
        try {
            document.getElementById("coll-see-more").style.display = "none";
        } catch (error) {
            console.error(error)
        }
        try {
            document.getElementById("coll-see-more").style.display = "none";
        } catch (error) {
            console.error(error)
        }
    }
    var currentDate = new Date();
    var currentMonth = currentDate.toLocaleString('en-US', {
        month: 'short'
    }).toLowerCase();
    // let card_index = 0;
    products.forEach((product, index) => {
        const prodCard = generateProductHtml({product, index});
        if(prodCard){
            target.append(prodCard);
        }
    });


    restoreBanners(bannerMap)
    prodsAddedFlag = true;
    startCookieObserver();
    let currency = document.body.getAttribute("currency")
    // Update prices for non-UK markets
    if (currency != "GPB") {
        
        const updatePromises = products.map(product => updateNonUKPrices(product.productId));
        await Promise.all(updatePromises);
        
        addLabels();
    } else {
        addLabels();
    }
}

async function updateNonUKPrices(productId) {
    try {
        const card = document.querySelector(`[data-product-id="${productId}"]`);
        if (!card) {
            debug.error(`Could not find card for product ID: ${productId}`);
            return;
        }

        const prodInfo = card.querySelector('.prod-info');

        const product = JSON.parse(prodInfo.value);

        const productHandle = getShopifyProductHandle(product.url);

        if (!productHandle) {
            return;
        }

       let currency = document.body.getAttribute("currency");
        const url = `/products/${productHandle}.js?country=${countryIso}` ;

        const response = await fetch(url);

        const shopifyProduct = await response.json();


        // Verify we have the correct product by comparing handles
        const shopifyHandle = shopifyProduct.handle;
        debug.log('[updateNonUKPrices] Comparing handles:', {
            shopifyHandle,
            productHandle
        });

        if (shopifyHandle !== productHandle) {
            return;
        }

        // Update price
        const priceElement = card.querySelector('.product-card__details__price');
        priceElement.setAttribute("price-updated", "true")
        if (is_sale) {
            const saleTag = product.tags1.find((tag) => {
                return tag.includes("lw-")
            })
            let saleAmount = Number(saleTag?.split("-").pop()) || 0;

            shopifyProduct.price = shopifyProduct.price * (1 - (saleAmount / 100));
        }
        if (priceElement) {
            let price = shopifyProduct.price;
            let comparePrice = shopifyProduct.compare_at_price;

            if (price % 100 !== 0) {
                price = parseFloat(price / 100).toFixed(2);
            } else {
                price = (price / 100);
            }

            const normalPrice = GEBO.settings.shop_money_format.replace(/\{\{.*?\}\}/, price)

            let listPriceElement = '';
            if (comparePrice && comparePrice > shopifyProduct.price) {
                if (comparePrice % 1 !== 0) {
                    comparePrice = parseFloat(comparePrice / 100).toFixed(2);
                } else {
                    comparePrice = (comparePrice / 100);
                }
                listPriceElement = `<del class="ml-1 text-gray-400">${GEBO.settings.shop_money_format.replace(/\{\{.*?\}\}/, comparePrice)}</del>`;
            } else {
                listPriceElement = `<del class="ml-1 text-gray-400 hidden">${GEBO.settings.shop_money_format.replace(/\{\{.*?\}\}/, price)}</del>`;
            }

            priceElement.innerHTML = `${normalPrice}${listPriceElement}`;
        }

        // Update title and product type
        const titleElement = card.querySelector('.product-card__details__title');
        const categoryElement = card.querySelector('.product-card__details__color');

        if (titleElement) {
            const titleLogicInput = {
                name: shopifyProduct.title,
                tags1: shopifyProduct.tags,
                compare_at_price: shopifyProduct.compare_at_price,
                price: shopifyProduct.price
            };

            const titleInfo = titleLogic(titleLogicInput);
         titleElement.textContent = titleInfo.cleanTitle;

            if (categoryElement && titleInfo.subTitle) {
                categoryElement.textContent = titleInfo.subTitle;
            }
        }

        // Update the stored product info
        const updatedProduct = {
            ...product,
            price: shopifyProduct.price / 100,
            listPrice: shopifyProduct.compare_at_price ? shopifyProduct.compare_at_price / 100 : shopifyProduct.price / 100,
            name: shopifyProduct.title,
            tags1: shopifyProduct.tags
        };
         prodInfo.value = JSON.stringify(updatedProduct);

        debug.log('Successfully updated product:', shopifyHandle);

    } catch (error) {
        debug.error('Error updating product info:', error);
        debug.error('Error stack:', error.stack);
    }
}

function titleLogic(product) {
    try {
        // Initial validation with detailed error
        if (!product) {
            debug.log('titleLogic: Product parameter is undefined or null');
            return {
                cleanTitle: '',
                subTitle: '',
                onSale: false
            };
        }

        if (!product.name) {
            debug.log('titleLogic: Product name is undefined or null');
            return {
                cleanTitle: '',
                subTitle: '',
                onSale: false
            };
        }

        let title = product.name;
        let cleanTitle = title;
        let subTitle = '';
        let onSale = false;

        try {
            // Safely check if product is on sale
            onSale = Boolean(product.compare_at_price > product.price);
        } catch (priceError) {
            debug.log('titleLogic: Error comparing prices:', priceError);
            onSale = false;
        }

        try {
            // Handle subscription products
            if (title.toLowerCase().includes("subscription") && !title.toLowerCase().includes("pre-paid") && false) {
                try {
                    let tags = Array.isArray(product.tags1) ? product.tags1 : [];
                    let temp = title.split("-");

                    for (let each of temp) {
                        if (each && each.toLowerCase().includes("sock")) {
                            cleanTitle = each.replace("& Sock", "& free sock");
                        }
                    }

                    if (tags.includes('subscription_classic')) {
                        subTitle = 'Plain Monthly Subscription';
                    } else if (tags.includes('subscription-patterned')) {
                        subTitle = "Patterned Monthly Subscription";
                    }
                } catch (subscriptionError) {
                    debug.log('titleLogic: Error processing subscription:', subscriptionError);
                }
            }
            // Handle pre-paid products 
            else if (title.toLowerCase().includes("pre-paid")) {
                try {
                    let tags = Array.isArray(product.tags1) ? product.tags1 : [];

                    if (tags.includes('subscription_classic')) {
                        subTitle = ' Plain Subscription';
                    } else if (tags.includes('subscription_adventurous')) {
                        subTitle = ' Patterned Subscription';
                    }

                    if (title.includes('06 Month Pre-Paid: ')) {
                        try {
                            cleanTitle = subTitle.replace('', '6 month pre-paid ');
                            title = title.replace('06 Month Pre-Paid: ', '')
                                .replace('CLASSIC Subscription - ', '')
                                .replace('[G2]', '')
                                .replace(' monthly subscription', '')
                                .toLowerCase();
                        } catch (sixMonthError) {
                            debug.log('titleLogic: Error processing 6-month pre-paid:', sixMonthError);
                        }
                    } else if (title.includes('12 Month Pre-Paid: ')) {
                        try {
                            cleanTitle = subTitle.replace('', '12 month pre-paid ');
                            title = title.replace('12 Month Pre-Paid: ', '')
                                .replace('CLASSIC Subscription - ', '')
                                .replace('[G2]', '')
                                .replace(' monthly subscription', '')
                                .toLowerCase();
                        } catch (twelveMonthError) {
                            debug.log('titleLogic: Error processing 12-month pre-paid:', twelveMonthError);
                        }
                    }
                } catch (prePaidError) {
                    debug.log('titleLogic: Error processing pre-paid subscription:', prePaidError);
                }
            }
            // Handle regular products
            else {
                try {
                    if (cleanTitle && cleanTitle.includes('-')) {
                        let cleanTitleArr = cleanTitle.split(' - ');
                        let cleanTitleFirst = cleanTitleArr[0] + ' - ';
                        subTitle = cleanTitle.replace(cleanTitleFirst, '');
                        cleanTitle = cleanTitleFirst.replace(' - ', '');
                    }
                } catch (regularProductError) {
                    debug.log('titleLogic: Error processing regular product:', regularProductError);
                }
            }
        } catch (mainLogicError) {
            debug.log('titleLogic: Error in main product type logic:', mainLogicError);
        }

        // Ensure clean return values
        return {
            cleanTitle: cleanTitle || '',
            subTitle: subTitle || '',
            onSale: Boolean(onSale)
        };

    } catch (globalError) {
        console.error('titleLogic: Critical error in title processing:', globalError);
        return {
            cleanTitle: product?.name || '',
            subTitle: '',
            onSale: false
        };
    }
}



document.body.addEventListener('click', function(event) {
    if(event.target.closest(".nlf-popup-trigger")){
        window._klOnsite = window._klOnsite || []; 
        window._klOnsite.push(['openForm', 'REJuhf']);
    }
    if(event.target.closest(".traitors-popup-trigger")){
        window._klOnsite = window._klOnsite || [];
         window._klOnsite.push(['openForm', 'YtSfx6']);
    }
    if(event.target.closest(".swim-shorts-popup-trigger")){
        window._klOnsite = window._klOnsite || [];
         window._klOnsite.push(['openForm', 'Rka3Mk'])
    }

    if(event.target.closest(".clear-all-nosto-filters")){
        filters = [];
        fetchCollProducts();
    }

    if(event.target.closest(".collection-in-wishlist")){
        event.preventDefault();
        event.stopPropagation();
        const customerInput = document.getElementById("customer-id-input");
        const customerId = customerInput?.value; 
        const productId = event.target.closest(".collection-in-wishlist").dataset.id;
        const wrapper = event.target.closest(".collection-in-wishlist");
        wrapper.classList.add("collection-not-in-wishlist");
        wrapper.classList.remove("collection-in-wishlist");
        wrapper.innerHTML = heartSvg;
        currentWishlistItem = productId;
                fetch("https://oddballs-whishlist--development.gadget.app/apps/oddballs-wishlist/remove-product", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        customerId: customerId,
                        productId: productId,
                        shopId: "3537249"
                    }),
                    mode: "cors"
                })
                .then((res) => res.json())
                .then((data) => {
                    if (data.success) {
                        //change from full to empty
                    }
                })
                .catch((err) => {
                    console.error("Error:", err);
                });
    }
    if(event.target.closest(".collection-not-in-wishlist")){
        event.preventDefault();
        event.stopPropagation();
        const wrapper = event.target.closest(".collection-not-in-wishlist");
        wrapper.innerHTML=fullHeartAnimation.outerHTML
        const customerInput = document.getElementById("customer-id-input");
        const customerId = customerInput?.value; 
        const productId = wrapper.dataset.id;
        wrapper.classList.remove("collection-not-in-wishlist");
        wrapper.classList.add("collection-in-wishlist");
        currentWishlistItem = productId;
            fetch("https://oddballs-whishlist--development.gadget.app/apps/oddballs-wishlist/add-product", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        customerId: customerId,
                        productId: productId,
                        shopId: "3537249"
                    }),
                    mode: "cors"
                })
                .then((res) => res.json())
                .then((data) => {
                    if (data.success) {
                        
                    }
                })
                .catch((err) => {
                    console.error("Error:", err);
                });

    }

    if (event.target.closest('#coll-see-more')) {
        event.preventDefault();
        const seeMoreButton = document.getElementById("coll-see-more");
        const from = parseInt(seeMoreButton.getAttribute("data-page-loc"));
        event.target.closest("#coll-see-more").classList.add("see-more-loading");
        seeMoreButton.setAttribute("data-page-loc", from + pageSize);
        fetchCollPage();
    }

    if (event.target.closest('.js-reset-filters')) {
        resetFilters();
    }
    if (event.target.closest('.coll-quick-add')) {
        if (window.ThemeType == "B") {
            // NEW SYSTEM: Use buildQb directly
            const wrapper = event.target.closest('.product-card');
            const prod = JSON.parse(wrapper.querySelector('.prod-info').value);
            // Prevent the old system from running by adding a flag
            wrapper.setAttribute('data-using-new-qb', 'true');
            buildQb(prod);
        } else {
            // OLD SYSTEM: Use existing showCollectionQuickBuyPopup
            const wrapper = event.target.closest('.product-card');
            // Check if new system is already running
            if (wrapper.getAttribute('data-using-new-qb') === 'true') {
                return; // Don't run old system if new one is active
            }
            event.target.closest(".quick-add-wrapper").classList.add("qb-loading");
            const prod = JSON.parse(wrapper.querySelector('.prod-info').value);
            if(event.target.closest(".flash-sale-product")){

                showCollectionQuickBuyPopup(prod, "qb-flash-sale")
            }else{

                showCollectionQuickBuyPopup(prod)
            }
        }
    }

    if (event.target.closest('#search-see-more')) {
        const seeMoreButton = document.getElementById("search-see-more");
        const from = parseInt(seeMoreButton.getAttribute("data-page-loc"));
        event.target.closest("#search-see-more").classList.add("see-more-loading");
        seeMoreButton.setAttribute("data-page-loc", from + pageSize);
        fetchSearchPage();
    }


    // if(event.target.closest('.coll-quick-add')){
    //   event.target.closest(".quick-add-wrapper").classList.add("qb-loading");
    //   const wrapper = event.target.closest('.product-card');
    //   const prod = JSON.parse(wrapper.querySelector('.prod-info').value);
    //   showCollectionQuickBuyPopup(prod)
    // }



    if (event.target.closest('.show-filters-button')) {
        sortFilters(globData.facets, globData.total);
    }


    if (event.target.closest('.filter-option-dropdown')) {
        const filterOptionDropdown = event.target.closest('.filter-option-dropdown');

        // Toggle the rotation class on the SVG element
        const svg = filterOptionDropdown.querySelector('svg');
        svg.classList.toggle('rotate-180');
        svg.classList.toggle('rotatable');

        // Toggle the visibility of the closest '.nosto-wrapper'
        const nostoWrapper = filterOptionDropdown.closest('.filter-outer-wrapper').querySelector('.nosto-wrapper');
        if (nostoWrapper) {
            nostoWrapper.style.display = (nostoWrapper.style.display === 'none' || nostoWrapper.style.display === '') ? 'grid' : 'none';
        }
    }
    if(event.target.closest(".collection-nav-link-reset-filter")){
        event.preventDefault();
        let previouslyActive = document.querySelectorAll(".collection-nav-link-with-filter.active");
        const container = document.getElementById("AjaxinateContainer");
        if(container){
            container.classList.add("collection-filtering")
        }
        if(previouslyActive){
            previouslyActive.forEach((filter, index)=>{
                filter.classList.remove("active")
                const oldFilterType = filter.dataset.filterType;
                const oldFilterValue = filter.dataset.filterValue;
                remFilterSearch(oldFilterType, oldFilterValue, index + 1 == Array.from(previouslyActive).length);
            });
            event.target.closest(".collection-nav-link-reset-filter").classList.add("active")
        }
    }else if(event.target.closest(".collection-nav-link-with-filter")){
        event.preventDefault();
        const container = document.getElementById("AjaxinateContainer");
        if(container){
            container.classList.add("collection-filtering")
        }
        let previouslyActive = document.querySelector(".collection-nav-link-with-filter.active");
        if(event.target.closest(".collection-nav-link-with-filter.active")){
            let currenActive = event.target.closest(".collection-nav-link-with-filter.active")
            currenActive.classList.remove("active");
            const oldFilterType = currenActive.dataset.filterType;
            const oldFilterValue = currenActive.dataset.filterValue;
            remFilterSearch(oldFilterType, oldFilterValue);
            return;
        }
        const currentLinkSelected = document.querySelector(".filter-active-link");
        if(currentLinkSelected){
            currentLinkSelected.classList.remove("filter-active-link")
        }
        // if(previouslyActive){
        //     previouslyActive.classList.remove("active");
        //     const oldFilterType = previouslyActive.dataset.filterType;
        //     const oldFilterValue = previouslyActive.dataset.filterValue;
        //     remFilterSearch(oldFilterType, oldFilterValue, false);
        // }
        const wrapper = event.target.closest(".collection-nav-link-with-filter");
        wrapper.classList.add("active")
        const filterType = wrapper.dataset.filterType;
        const filterValue = wrapper.dataset.filterValue;
        const newFilter = {
            field: filterType,
            value: filterValue
        };
        filterSearch(newFilter);
    }

    if(event.target.closest(".collection-multi-filtersize-option")){
        let previouslyActive = event.target.closest(".collection-multi-filtersize-option.active")
        const container = document.getElementById("AjaxinateContainer");
        if(container){
            container.classList.add("collection-filtering")
        }
        if(previouslyActive){
            previouslyActive.classList.remove("active");
            const oldFilterType = previouslyActive.dataset.filterType;
            const oldFilterValue = previouslyActive.dataset.filterValue;
            remFilterSearch(oldFilterType, oldFilterValue);
            return
        }
        const wrapper = event.target.closest(".collection-multi-filtersize-option");
        wrapper.classList.add("active")
        const filterType = wrapper.dataset.filterType;
        const filterValue = wrapper.dataset.filterValue;
        const newFilter = {
            field: filterType,
            value: filterValue
        };
        filterSearch(newFilter);
    }

    if(event.target.closest(".collection-fiter-dropdown-option")){
        event.preventDefault();
        const target = event.target.closest(".collection-fiter-dropdown-option");
        // const oldValue = event.target.closest(".collection-filter-dropdown-options").querySelector(".collection-fiter-dropdown-option:has(input:checked)");
        // if(oldValue){
        //     const oldFilterType = oldValue.dataset.filterType;
        //     const oldFilterValue = oldValue.dataset.filterValue;
        //     remFilterSearch(oldFilterType, oldFilterValue, false);
        // }
        if(event.target.closest(".collection-filter-dropdown-clear-all")){
            const activeFilters = Array.from(event.target.closest(".collection-filter-dropdown-options").querySelectorAll("input:checked"));
            activeFilters.forEach((input, index)=>{
                const wrapper = input.closest(".collection-fiter-dropdown-option");
                const filterType = wrapper.dataset.filterType;
                const filterValue = wrapper.dataset.filterValue;
                const newFilter = {
                    field: filterType,
                    value: filterValue
                };
                remFilterSearch(filterType, filterValue, (index + 1) == activeFilters.length) //if it is the last filter, refresh the collection
            })
        }else{

            const filterType = target.dataset.filterType;
            const filterValue = target.dataset.filterValue;
            const newFilter = {
                field: filterType,
                value: filterValue
            };
            let closeInput = event.target.closest(".collection-filter-dropdown").querySelector(".collection-filter-dropdown-header input")
            closeInput.checked = false;
            if(target.querySelector("input:checked")){
                remFilterSearch(filterType, filterValue, true);
                target.querySelector("input").checked = false;
            }else{
                
                target.querySelector("input").checked = true;
                // event.target.closest(".collection-filter-dropdown").querySelector(".collection-filter-dropdown-option-chosen-value").innerHTML = filterValue.replace(/-/g, " ").replace("size ", "");
                filterSearch(newFilter);
            }
        }
        }
        
    if(event.target.closest(".collection-filter-dropdown-option-chosen-value-wrapper")){
        // event.preventDefault(); // stop dorpdown opening;
        // const selectedValue = event.target.closest(".collection-filter-dropdown").querySelector(".collection-fiter-dropdown-option:has(input:checked)")
        // const oldFilterType = selectedValue.dataset.filterType;
        // const oldFilterValue = selectedValue.dataset.filterValue;
        // remFilterSearch(oldFilterType, oldFilterValue);
        // const input = selectedValue.querySelector("input");
        // input.checked = false;
    }

    if (event.target.closest('.nosto-option-wrapper')) {
        event.preventDefault();
        const nostoOptionWrapper = event.target.closest('.nosto-option-wrapper');
        const facetName = nostoOptionWrapper.querySelector('.facet-name');
        facetName.classList.add("nosto-blur");

        const filterType = nostoOptionWrapper.closest('.nosto-wrapper').dataset.filterType;
        const optionValue = nostoOptionWrapper.dataset.optionValue;

        if (!facetName.classList.contains("active-filter")) { // If the filter isn't already selected
            const newFilter = {
                field: filterType,
                value: optionValue
            };
            filterSearch(newFilter);
        } else { // Otherwise, remove the filter
            remFilterSearch(filterType, optionValue);
        }
    }
    if (event.target.closest('#nosto-search-active-price')) {
        document.getElementById("nosto-search-active-price").remove();

        filters = filters.filter((item) => {
            return item.field != "price";
        })
        fetchCollProducts();
    }
    if (event.target.closest('.nosto-active-filter-option')) {
        const nostoOptionWrapper = event.target.closest('.nosto-active-filter-option');

        const filterType = nostoOptionWrapper.getAttribute("data-facet-cat")
        const optionValue = nostoOptionWrapper.getAttribute("data-filter-value");

        remFilterSearch(filterType, optionValue);
    }
    if (event.target.closest('.sort-option')) {
        const wrapper = event.target.closest('.sort-option');
        const sortType = wrapper.getAttribute('data-sort');
        if (sortType == "relevance") {
            currentSort = [];
            if (searchPageInput) { //get products for search
                let query = searchPageInput.value;
                fetchSearchProducts(query);
            } else {
                fetchCollProducts(); // Get products on collection load
            }
        }
        if (sortType == "asc") {
            currentSort = [{
                field: "price",
                order: "asc"
            }];
            if (searchPageInput) { //get products for search
                let query = searchPageInput.value;
                fetchSearchProducts(query);
            } else {
                fetchCollProducts(); // Get products on collection load
            }
        }
        if (sortType == "desc") {
            currentSort = [{
                field: "price",
                order: "desc"
            }];
            if (searchPageInput) { //get products for search
                let query = searchPageInput.value;
                fetchSearchProducts(query);
            } else {
                fetchCollProducts(); // Get products on collection load
            }
        }




    }
})

// Creates the print part of active filters
function createPrintCard(facet) {
    const print_tags = facet.data; // all prints in the collection
    const active_tags = print_tags.filter(function(thing) { // gets prints that have a filter applied to them
        return thing.selected;
    });

    for (const globPrint of glob_designs) { // loop through metaobjects
        let current_tag = globPrint.tag;
        let current_url = globPrint.img_url;
        let current_title = globPrint.title;

        for (const tagPrint of active_tags) { // for each active filter, create the element and append it to the active filters section
            if (tagPrint.value.replace("design-", "") === current_tag) {
                const opWrapper = document.createElement('span');
                opWrapper.className = "gap-3 nosto-active-filter-option nosto-active-filter inline-flex items-center px-2 py-2 me-2 text-xs font-medium text-white bg-cyan rounded-full";
                opWrapper.setAttribute("data-facet-cat", facet.field);
                opWrapper.setAttribute("data-filter-value", tagPrint.value);
                const text = document.createElement('div');
                text.textContent = tagPrint.value.replace("-", " "); // Replace hyphen with space
                text.className = "h-min";
                const img = document.createElement('img');
                img.className = "rounded-full w-4";
                img.src = current_url.replace(".jpg", "_40x.jpg").replace(".png", "_40x.png").replace("_100x", "");

                const button = document.createElement('button');
                button.type = "button";
                button.className = "inline-flex items-center p-1 ms-2 text-sm text-white bg-transparent rounded-sm hover:bg-cyan-600 hover:text-white";
                button.setAttribute("data-dismiss-target", "#badge-dismiss-default");
                button.setAttribute("aria-label", "Remove");
                const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                svg.style.height="0.5rem"
                svg.style.width ="0.5rem"
                svg.setAttribute("aria-hidden", "true");
                svg.setAttribute("fill", "none");
                svg.setAttribute("viewBox", "0 0 14 14");

                const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
                path.setAttribute("stroke", "currentColor");
                path.setAttribute("stroke-linecap", "round");
                path.setAttribute("stroke-linejoin", "round");
                path.setAttribute("stroke-width", "2");
                path.setAttribute("d", "m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6");
                svg.appendChild(path);
                svg.classList.add("w-2")
                svg.classList.add("h-2")
                const srOnlySpan = document.createElement('span');
                srOnlySpan.className = "sr-only";
                srOnlySpan.textContent = "Remove badge";
                button.appendChild(svg);
                button.appendChild(srOnlySpan);
                opWrapper.appendChild(img);
                opWrapper.appendChild(text);
                opWrapper.appendChild(button);
                document.getElementById('nosto-search-active-filters').appendChild(opWrapper);

            }
        }
    }
}

// Creates the size active filters from size tags
function createSizeCard(facet) {
    // Create a new Set to store unique size values
    const sizeSet = new Set();

    // Convert Map values to array before using forEach
    Array.from(sizeMap.values()).forEach(values => {
        values.forEach(value => sizeSet.add(value));
    });

    // Filter the facet data to only include tags that are present in the sizeSet
    const size_tags = facet.data.filter(function(tag) {
        return sizeSet.has(tag.value);
    });

    // Further filter the size_tags to find those that are currently selected
    const active_tags = size_tags.filter(function(thing) {
        return thing.selected;
    });

    // Loop through each entry in the sizeMap
    Array.from(sizeMap.entries()).forEach(([key, values]) => {
        const filters = [];
        let found = false;

        // Create a human-readable version of the size key by replacing dashes with spaces and capitalizing the words
        let humanReadable = key.replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase());

        // Loop through each active tag to check if it is part of the current size values
        active_tags.forEach(each => {
            if (values.includes(each.value)) {
                // If a match is found, mark it as found and add the value to the filters array
                found = true;
                filters.push(each.value);
            }
        });

        // If any matching active tags were found for the current size key
        if (found) {
            // Create a div element to represent the active filter
            const active_filter = document.createElement('div');
            active_filter.setAttribute("data-facet-cat", facet.field);
            active_filter.setAttribute("data-filter-value", filters);
            active_filter.textContent = humanReadable; // Use humanReadable for display
            active_filter.className = "flex border border-solid border-gray-300 w-max rounded-full w-min px-2 nosto-active-filter nosto-active-filter-option text-xs py-2 h-min w-min";

            const closeButton = document.createElement('span');
            closeButton.textContent = "x";
            closeButton.className = "ml-1 text-red-500";

            active_filter.appendChild(closeButton);
            document.getElementById('nosto-search-active-filters').appendChild(active_filter);
        }
    });
}



// Updates current filters to add a new filter
//@param newFilter: the filter to be added
function filterSearch(newFilter) {

    // If newFilter.value is a string and contains commas, split it into an array
    if (typeof newFilter.value === 'string' && newFilter.value.includes(",")) {
        newFilter.value = newFilter.value.split(",").map(v => v.trim()); // Trim whitespace
    } else if (typeof newFilter.value === 'string') {
        // Ensure single string values are treated correctly
        newFilter.value = [newFilter.value.trim()];
    }

    // Initialize filters array
    let func_filters = [];

    if (filters.length > 0) {
        // Filter out the existing filters for the same field
        func_filters = filters.filter(f => f.field !== newFilter.field);

        // Check for previous filters with the same field
        const prev_filter = filters.filter(f => f.field === newFilter.field);

        if (!newFilter.range) {
            if (prev_filter.length > 0) {
                const past_values = prev_filter[0].value;
                const new_values = newFilter.value;

                // Ensure past_values is always an array
                const normalized_past_values = Array.isArray(past_values) ? past_values : [past_values];

                // Combine old and new values and remove duplicates
                const combined_values = [...new Set([...normalized_past_values, ...new_values])];

                newFilter.value = combined_values;
            }
        }
    }

    // Add the new filter
    func_filters.push(newFilter);
    filters = func_filters;

    // Perform the search with updated filters
    // const query = document.getElementById('nosto-search-input').value;
    // document.getElementById('nosto-search-input').setAttribute("data-query", query);

    if (searchPageInput) { //get products for search
        let query = searchPageInput.value;
        fetchSearchProducts(query);
    } else {
        fetchCollProducts(); // Get products on collection load
    }
}

function hasVeryMeReward() {
  return document.cookie
    .split("; ")
    .some(cookie => cookie.startsWith("veryme_reward=true"));
}

function showCollectionQuickBuyPopup(product, view = "qb") {

    const currency = document.body.getAttribute("currency");

    let countryUrl = document.body.getAttribute("country-url");
    countryUrl = (countryUrl == "/") ? "" : "";
    product.url = product.url.replace(/^https?:\/\/www\.myoddballs\.com/, "");


    // Construct view parameter with proper format
    const viewParam = `?view=${view}&currency=${currency}`;
    let url = countryUrl + product.url + viewParam;

    fetch(url)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            return response.text();
        })
        .then(data => {
            const loaders = document.querySelectorAll('.qb-loading');
            loaders.forEach(item => {
                item.classList.remove("qb-loading");
            })
            const qbLoc = document.getElementById("default-quick-buy-content");
            qbLoc.innerHTML = data;
            const qbPopup = document.getElementById("default-quick-buy-popup-content");
            const cohortACheck = document.getElementById("winter-banner-version-a")
            const cohortBCheck = document.getElementById("winter-sale-banner-version-b")
            const cohort = cohortACheck? "a" : cohortBCheck? "b" : "C" ;
            if (hasVeryMeReward()) { 
                const inputToAdd  = `<input type="hidden" name="properties[_campaign]" value="vodafone-bogof-q1-2026" />`
                const prodForm = qbLoc.querySelector(".product-form");
                if(prodForm.classList.contains("vodafone-bogof")){
                    prodForm.insertAdjacentHTML("afterbegin",inputToAdd)
                }
            }else{
                console.log("No cookie")
            }
            const winter10Banner = document.getElementById("qb-winter-10-banner");
      if(winter10Banner && cohort == "a"){
        winter10Banner.style.display="block";
        const triggerBanner = document.createElement("div")
        triggerBanner.dataset.dataCroFeatureLoaded = "winter-sale-banner"
        document.body.append(triggerBanner);
      }
            openPopup(qbPopup);
        })

}


function openPopup(target) {
    document.body.classList.add("body-popup-active");
    let popupZindex = 2;
    const popupContent = target.closest('.page-popup-content');
    if (popupContent) {
        popupContent.style.zIndex = popupZindex;
    } else {
        console.error("No matching popup content found.");
    }
    target.style.display = "block";
    setTimeout(function() {
        target.classList.add('popup-active');
    }, 1);
}

function modifyUrlWithResolutions(url) { // used to return a source set with multiple resolutions
    var resolutions = [360, 420, 480, 640, 840, 1080, 1280, 1540, 1860, 1950];
    var parts = url.split('.');
    var fileName = parts.slice(0, -1).join('.');
    var fileExtension = parts[parts.length - 1];
    var modifiedUrls = [];

    for (var i = 0; i < resolutions.length; i++) {
        var resolution = resolutions[i];
        var modifiedUrl = fileName + "_" + (resolution / 4) + "x." + fileExtension + " " + resolution / 4 + "w";
        modifiedUrls.push(modifiedUrl);
    }

    var result = '';
    for (var j = 0; j < modifiedUrls.length; j++) {
        result += modifiedUrls[j];
        if (j !== modifiedUrls.length - 1) {
            result += ',';
        }

    }
    //return("")
    return result;
}

function onElementInView(entry) {
    const cookieMonsterDiv = document.createElement("div");
    cookieMonsterDiv.style.position = "absolute";
    cookieMonsterDiv.style.left = "0px";
    cookieMonsterDiv.style.top = "50%";
    cookieMonsterDiv.style.pointerEvents = "none";
    cookieMonsterDiv.style.width = "200px";

    const image = document.createElement("img");
    image.src = "https://cdn.shopify.com/s/files/1/0353/7249/files/Cookie-Monster-GIF-1-_NO-LOOP.gif";
    cookieMonsterDiv.appendChild(image)
    entry.target.appendChild(cookieMonsterDiv)
    observer.unobserve(entry.target);
}

// Create the IntersectionObserver
const observer = new IntersectionObserver(
    (entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                onElementInView(entry);
            }
        });
    }, {
        root: null, // viewport
        rootMargin: "0px",
        threshold: 0.1 // trigger when 10% of element is visible
    }
);

// Select all elements with the class
const startCookieObserver = () => {

    const elements = document.querySelectorAll(".cookie-monster-product");
    elements.forEach((el) => observer.observe(el));
}